// import { useEffect, useMemo, useState } from "react";

// type LoadStatus = "In-transit" | "Delivered" | "Upcoming";
// type ApiStatus = "pending" | "booked" | "in_transit" | "delivered" | "cancelled";

// interface Load {
//   id: string;
//   name: string;
//   shipmentId: number;
//   status: LoadStatus;
//   progress: number;
//   pickupDate: string;
//   deliveryDate: string;
//   from: string;
//   to: string;
// }

// interface LoadDetail {
//   id: string;
//   pickupDate: string;
//   deliveryDate: string;
//   pickupLocation: string;
//   deliveryLocation: string;
//   driver: string;
//   truck: string;
//   traveled: string;
//   speed: string;
// }

// type ShipmentRow = {
//   id: number;
//   lr_number: string;
//   consignor_id: number;
//   receiver_id: number;
//   transporter_id: number;
//   status: ApiStatus;
//   pickup_address: string;
//   delivery_address: string;
//   pickup_date: string;
//   delivery_date: string;
//   total_amount: number;
// };

// type ShipmentDetailResponse = {
//   id: number;
//   lr_number: string;
//   status: ApiStatus;
//   pickup_address: string;
//   delivery_address: string;
//   pickup_date: string;
//   delivery_date: string;
//   items: RowDataPacketLike[];
//   charges: RowDataPacketLike[];
// };

// type RowDataPacketLike = {
//   [key: string]: unknown;
// };

// const statusColors: Record<LoadStatus, string> = {
//   "In-transit": "bg-blue-100 text-blue-600",
//   "Delivered": "bg-green-100 text-green-600",
//   "Upcoming": "bg-orange-100 text-orange-500",
// };

// const formatDate = (value?: string | Date | null): string => {
//   if (!value) return "-";
//   const d = new Date(value);
//   return Number.isNaN(d.getTime()) ? "-" : d.toLocaleDateString();
// };

// const toUiStatus = (status: ApiStatus): LoadStatus => {
//   if (status === "delivered") return "Delivered";
//   if (status === "in_transit" || status === "booked") return "In-transit";
//   return "Upcoming";
// };

// const progressForStatus = (status: LoadStatus): number => {
//   if (status === "Delivered") return 100;
//   if (status === "In-transit") return 70;
//   return 25;
// };

// const initials = (value: string): string => {
//   const s = String(value || "").replace(/\s+/g, " ").trim();
//   if (!s) return "NA";
//   const parts = s.split(" ").filter(Boolean);
//   const first = parts[0]?.[0] ?? "N";
//   const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : parts[0]?.[1];
//   return `${first}${last ?? ""}`.toUpperCase();
// };

// const AdminDashboard = () => {
//   const [activeTab, setActiveTab] = useState("All Loads");
//   const [loads, setLoads] = useState<Load[]>([]);
//   const [selectedLoad, setSelectedLoad] = useState<string | null>(null);
//   const [selectedLoadId, setSelectedLoadId] = useState<number | null>(null);
//   const [showDetail, setShowDetail] = useState(true);
//   const [detail, setDetail] = useState<LoadDetail | null>(null);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [downloadingInvoice, setDownloadingInvoice] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const apiUrl = process.env.REACT_APP_API_URL;
//     if (!token || !apiUrl) {
//       setLoading(false);
//       setError("Missing token or API URL");
//       return;
//     }

//     let mounted = true;
//     const fetchShipments = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${apiUrl}/auth/consignments`);
//         if (!response.ok) {
//           throw new Error("Failed to fetch shipments");
//         }
//         const data = (await response.json()) as ShipmentRow[];
//         if (!mounted) return;

//         const mapped: Load[] = data.map((row) => ({
//           id: row.lr_number ? row.lr_number : `#${row.id}`,
//           shipmentId: row.id,
//           name: `Consignment ${row.id}`,
//           status: toUiStatus(row.status),
//           progress: progressForStatus(toUiStatus(row.status)),
//           pickupDate: formatDate(row.pickup_date),
//           deliveryDate: formatDate(row.delivery_date),
//           from: row.pickup_address || `Consignor ${row.consignor_id}`,
//           to: row.delivery_address || `Receiver ${row.receiver_id}`,
//         }));

//         setLoads(mapped);
//         if (mapped.length > 0) {
//           setSelectedLoad(mapped[0].id);
//           setSelectedLoadId(mapped[0].shipmentId);
//         }
//         setError(null);
//       } catch (_err) {
//         if (mounted) setError("Could not load shipments from API");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     };

//     fetchShipments();
//     return () => {
//       mounted = false;
//     };
//   }, []);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const apiUrl = process.env.REACT_APP_API_URL;
//     if (!selectedLoadId || !token || !apiUrl) return;

//     let mounted = true;
//     const fetchDetail = async () => {
//       try {
//         const response = await fetch(`${apiUrl}/auth/consignments/${selectedLoadId}`);
//         if (!response.ok) return;
//         const data = (await response.json()) as ShipmentDetailResponse;
//         if (!mounted) return;
//         const totalCharges = (data.charges || []).reduce((sum, charge) => sum + Number(charge.amount || 0), 0);

//         setDetail({
//           id: data.lr_number ? data.lr_number : `#${data.id}`,
//           pickupDate: formatDate(data.pickup_date),
//           deliveryDate: formatDate(data.delivery_date),
//           pickupLocation: data.pickup_address || "Pickup location unavailable",
//           deliveryLocation: data.delivery_address || "Delivery location unavailable",
//           driver: "Assigned by transporter",
//           truck: "Vehicle assigned",
//           traveled: `${Math.max(0, Number(data.items?.length || 0))} stops`,
//           speed: `${Math.max(0, Math.round(totalCharges / 100))} km/h`,
//         });
//       } catch {
//         // keep existing detail state
//       }
//     };

//     fetchDetail();
//     return () => {
//       mounted = false;
//     };
//   }, [selectedLoadId]);

//   const filteredLoads = useMemo(() => {
//     let result = loads;
//     if (activeTab === "In-transit") result = result.filter((l) => l.status === "In-transit");
//     if (activeTab === "Delivery") result = result.filter((l) => l.status === "Delivered");
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       result = result.filter((l) => l.id.toLowerCase().includes(q) || l.name.toLowerCase().includes(q));
//     }
//     return result;
//   }, [loads, activeTab, search]);

//   const tabs = useMemo(
//     () => [
//       { label: "All Loads", count: loads.length },
//       { label: "In-transit", count: loads.filter((l) => l.status === "In-transit").length },
//       { label: "Delivery", count: loads.filter((l) => l.status === "Delivered").length },
//     ],
//     [loads]
//   );

//   const stats = useMemo(() => {
//     const inTransit = loads.filter((l) => l.status === "In-transit").length;
//     const delivered = loads.filter((l) => l.status === "Delivered").length;
//     const total = loads.length;
//     const onTimeRate = total ? ((delivered / total) * 100).toFixed(1) : "0.0";
//     return { inTransit, delivered, total, onTimeRate };
//   }, [loads]);

//   const downloadInvoicePdf = async (): Promise<void> => {
//     const apiUrl = process.env.REACT_APP_API_URL;
//     if (!apiUrl || !selectedLoadId) return;
//     try {
//       setDownloadingInvoice(true);
//       const response = await fetch(`${apiUrl}/auth/consignments/${selectedLoadId}/invoice/pdf`);
//       if (!response.ok) throw new Error("Failed to download invoice");
//       const blob = await response.blob();
//       const fileUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = fileUrl;
//       link.download = `invoice-${selectedLoadId}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(fileUrl);
//     } catch {
//       // silent fail for now
//     } finally {
//       setDownloadingInvoice(false);
//     }
//   };

//   // Responsive logic for showing/hiding sidebar and detail on mobile
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [detailOpen, setDetailOpen] = useState(false);

//   // Open detail sidebar on mobile when a load is picked
//   useEffect(() => {
//     if (selectedLoadId && window.innerWidth < 768) {
//       setDetailOpen(true);
//     }
//   }, [selectedLoadId]);

//   // Utility to handle window resize for responsiveness
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 768) {
//         setSidebarOpen(false);
//         setDetailOpen(false);
//       }
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div className="flex flex-col md:flex-row h-full min-h-[680px] bg-gray-50 font-sans overflow-hidden relative">
//       {/* Mobile sidebar button */}
//       <button
//         className="md:hidden fixed top-1 left-1 z-30 bg-white border border-gray-200 rounded-full p-2 shadow"
//         aria-label="Open sidebar"
//         onClick={() => setSidebarOpen(true)}
//       >
//         {/* Hamburger */}
//         <svg width="24" height="24" fill="none" stroke="#222" strokeWidth="2" viewBox="0 0 24 24">
//           <path d="M4 7h16M4 12h16M4 17h16" />
//         </svg>
//       </button>

//       {/* Sidebar */}
//       <div
//         className={`
//           fixed md:static top-0 left-0 z-40 
//           w-11/12 max-w-xs md:w-[25%]
//           h-full bg-white border-r border-gray-100 flex flex-col flex-shrink-0 transition-transform duration-200 
//           ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0
//         `}
//         style={{ boxShadow: sidebarOpen ? "0 2px 10px rgba(0,0,0,0.12)" : undefined }}
//       >
//         {/* Sidebar close (mobile) */}
//         <div className="md:hidden flex justify-end p-3">
//           <button 
//             onClick={() => setSidebarOpen(false)} 
//             className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center"
//             aria-label="Close sidebar"
//           >
//             <svg width="14" height="14" fill="none" stroke="#222" strokeWidth="2" viewBox="0 0 24 24">
//               <path d="M18 6L6 18M6 6l12 12" />
//             </svg>
//           </button>
//         </div>
//         <div className="px-4 pt-5 pb-3">
//           <div className="flex items-center justify-between mb-4">
//             <h1 className="text-lg font-bold text-gray-900 tracking-tight">Tracking Loads</h1>
//             <div className="flex items-center gap-2">
//               <button className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center shadow-sm">
//                 <svg width="14" height="14" fill="white" viewBox="0 0 24 24"><path d="M12 22c1.1 0 2-.9 2-2H10c0 1.1.9 2 2 2zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" /></svg>
//               </button>
//               <button className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
//                 <svg width="14" height="14" fill="#666" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" /></svg>
//               </button>
//               <div className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-white text-xs font-bold">MR</div>
//             </div>
//           </div>
//           <div className="relative">
//             <svg className="absolute left-3 top-2.5 text-gray-400" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
//             <input
//               className="w-full pl-9 pr-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-100 placeholder-gray-400"
//               placeholder="Search"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="flex gap-1 px-4 pb-3">
//           {tabs.map((tab) => (
//             <button
//               key={tab.label}
//               onClick={() => setActiveTab(tab.label)}
//               className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${
//                 activeTab === tab.label ? "bg-blue-600 text-white shadow-sm" : "text-gray-500 hover:bg-gray-100"
//               }`}
//             >
//               {tab.label}
//               <span className={`text-xs rounded-full px-1.5 py-0.5 ${activeTab === tab.label ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-600"}`}>
//                 {tab.count}
//               </span>
//             </button>
//           ))}
//         </div>

//         <div className="flex-1 overflow-y-auto px-3 space-y-2 pb-4 group bw-scroll">
//           {loading && <div className="text-xs text-gray-500 px-1">Loading shipments...</div>}
//           {error && <div className="text-xs text-rose-500 px-1">{error}</div>}
//           {!loading && !error && filteredLoads.length === 0 && (
//             <div className="text-xs text-gray-500 px-1">No shipments found</div>
//           )}
//           {filteredLoads.map((load, i) => (
//             <button
//               key={`${load.id}-${i}`}
//               onClick={() => {
//                 setSelectedLoad(load.id);
//                 setSelectedLoadId(load.shipmentId);
//                 setShowDetail(true);
//                 if (window.innerWidth < 768) {
//                   setSidebarOpen(false);
//                   setDetailOpen(true);
//                 }
//               }}
//               className={`w-full text-left p-3 rounded-xl border transition-all ${
//                 selectedLoad === load.id ? "border-blue-200 bg-blue-50 shadow-sm" : "border-gray-100 bg-white hover:border-gray-200 hover:shadow-sm"
//               }`}
//             >
//               <div className="flex items-start justify-between mb-2">
//                 <div>
//                   <p className="text-sm font-semibold text-gray-900">{load.name}</p>
//                   <p className="text-xs text-gray-400">{load.id}</p>
//                 </div>
//                 <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusColors[load.status]}`}>{load.status}</span>
//               </div>
//               <div className="flex items-center gap-2 text-xs text-gray-500">
//                 <span>{load.pickupDate}</span>
//                 <div className="flex-1 flex items-center gap-1">
//                   <div className="w-2 h-2 rounded-full bg-blue-400 flex-shrink-0" />
//                   <div className="flex-1 border-t border-dashed border-gray-300" />
//                   <svg width="12" height="12" fill="#94a3b8" viewBox="0 0 24 24"><path d="M17 8C8 10 5.9 16.17 3.82 21L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20c4 0 4-2 8-2s4 2 8 2v-2c-4 0-4-2-8-2c-1.13 0-1.9.16-2.53.33C14.28 12.07 16 9.66 17 8z" /></svg>
//                 </div>
//                 <span>{load.deliveryDate}</span>
//               </div>
//               <div className="flex justify-between text-xs text-gray-400 mt-1">
//                 <span>{load.from}</span>
//                 <span>{load.to}</span>
//               </div>

//               {/* Thumbnails + progress (show on hover over overflow list) */}
//               <div className="mt-3 opacity-0 max-h-0 overflow-hidden transition-all duration-200 group-hover:opacity-100 group-hover:max-h-24">
//                 <div className="flex items-center justify-between">
//                   <div className="flex -space-x-2">
//                     {[
//                       { label: initials(load.from), tone: "bg-black text-white" },
//                       { label: initials(load.to), tone: "bg-white text-black border border-gray-300" },
//                       { label: "LR", tone: "bg-gray-200 text-gray-800" },
//                     ].map((t, idx) => (
//                       <div
//                         key={`${t.label}-${idx}`}
//                         className={`w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold shadow-sm ${t.tone}`}
//                         title={idx === 0 ? "Pickup" : idx === 1 ? "Delivery" : "LR"}
//                       >
//                         {t.label}
//                       </div>
//                     ))}
//                   </div>
//                   <div className="text-[10px] text-gray-500 font-semibold">
//                     {load.progress}%
//                   </div>
//                 </div>
//                 <div className="mt-2 w-full h-2 rounded-full bg-gray-200 overflow-hidden">
//                   <div
//                     className="h-full rounded-full bg-black transition-all duration-300"
//                     style={{ width: `${load.progress}%` }}
//                   />
//                 </div>
//               </div>
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Overlay for closing the sidebar (mobile) */}
//       {sidebarOpen && (
//         <div 
//           className="fixed inset-0 bg-black/20 z-30 md:hidden"
//           onClick={() => setSidebarOpen(false)}
//           aria-label="Close sidebar overlay"
//         />
//       )}

//       <div className="flex-1 flex flex-col overflow-hidden">
//         <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 p-5 pb-0">
//           {[
//             { label: "Active Loads", value: `${stats.inTransit}`, icon: "🚛", color: "bg-blue-50 border-blue-100" },
//             { label: "Total Deliveries", value: `${stats.delivered}`, icon: "📦", color: "bg-orange-50 border-orange-100" },
//             { label: "On-Time Rate", value: `${stats.onTimeRate}%`, icon: "⏱️", color: "bg-teal-50 border-teal-100" },
//             { label: "Total Loads", value: `${stats.total}`, icon: "📊", color: "bg-green-50 border-green-100" },
//           ].map((stat) => (
//             <div key={stat.label} className={`rounded-2xl border p-4 ${stat.color} bg-white flex items-center gap-3 shadow-sm`}>
//               <span className="text-2xl">{stat.icon}</span>
//               <div>
//                 <p className="text-xl font-bold text-gray-900">{stat.value}</p>
//                 <p className="text-xs text-gray-500">{stat.label}</p>
//               </div>
//               <button className="ml-auto text-gray-400 hover:text-gray-600">
//                 <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" /></svg>
//               </button>
//             </div>
//           ))}
//         </div>

//         <div className="flex-1 relative m-0 md:m-5 md:mt-4 rounded-none md:rounded-2xl overflow-hidden shadow-sm border-0 md:border md:border-gray-100">
//           <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-blue-50 to-slate-200">
//             <svg width="100%" height="100%" className="opacity-30">
//               <defs>
//                 <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
//                   <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#94a3b8" strokeWidth="0.5" />
//                 </pattern>
//               </defs>
//               <rect width="100%" height="100%" fill="url(#grid)" />
//             </svg>
//             <svg className="absolute inset-0 w-full h-full opacity-40 pointer-events-none">
//               <line x1="0" y1="40%" x2="100%" y2="40%" stroke="#94a3b8" strokeWidth="2" />
//               <line x1="0" y1="65%" x2="100%" y2="65%" stroke="#94a3b8" strokeWidth="1.5" />
//               <line x1="30%" y1="0" x2="30%" y2="100%" stroke="#94a3b8" strokeWidth="1.5" />
//               <line x1="60%" y1="0" x2="60%" y2="100%" stroke="#94a3b8" strokeWidth="2" />
//             </svg>
//             <svg className="absolute inset-0 w-full h-full pointer-events-none">
//               <polyline points="200,300 350,250 500,200 650,160" fill="none" stroke="#3b82f6" strokeWidth="3" strokeDasharray="8 4" opacity="0.8" />
//             </svg>
//             {/* Hide map markers on extra small screens for clarity */}
//             <div className="hidden sm:block absolute" style={{ left: "58%", top: "28%" }}>
//               <div className="relative">
//                 <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white">
//                   <div className="w-3 h-3 bg-white rounded-full" />
//                 </div>
//                 <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-red-500 rotate-45" />
//               </div>
//             </div>
//             <div className="hidden sm:block absolute" style={{ left: "38%", top: "44%" }}>
//               <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md border border-gray-200">
//                 <span className="text-sm">🚛</span>
//               </div>
//             </div>
//             <div className="absolute top-4 left-1/2 text-xs font-semibold text-gray-500 uppercase tracking-widest hidden md:block">ALL-LINN</div>
//             <div className="absolute top-16 right-1/3 text-xs text-gray-400 font-medium hidden lg:block">Rant 2</div>
//             <div className="absolute top-1/3 left-1/4 text-xs font-bold text-gray-600 uppercase tracking-wide hidden md:block">SIBU LAAKULA</div>
//             <div className="absolute bottom-1/4 left-1/3 text-xs text-gray-500 uppercase tracking-wide hidden lg:block">KESKLINN</div>
//             <div className="absolute bottom-1/3 left-1/6 text-xs text-gray-400 hidden xl:block">MAAILM</div>
//             <div className="absolute bottom-8 left-1/3 text-xs text-gray-400 italic hidden md:block">A. La Coq Arena</div>
//             <div className="absolute top-4 right-4 flex flex-col gap-1 hidden md:flex">
//               <button className="w-7 h-7 bg-white rounded-md shadow flex items-center justify-center text-gray-600 font-bold hover:bg-gray-50">+</button>
//               <button className="w-7 h-7 bg-white rounded-md shadow flex items-center justify-center text-gray-600 font-bold hover:bg-gray-50">-</button>
//             </div>
//           </div>

//           {/* Detail panel for desktop, modal for mobile */}
//           {/* Mobile overlay for detail */}
//           {detailOpen && (
//             <div className="fixed inset-0 z-50 bg-black/30 flex md:hidden">
//               <div className="w-full max-w-xs mx-auto my-auto bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden relative animate-fadeIn">
//                 <div className="flex items-center justify-between px-4 py-3 border-b border-gray-50">
//                   <div>
//                     <p className="text-xs text-gray-400">Load id:</p>
//                     <p className="text-sm font-bold text-gray-900">{detail?.id || "-"}</p>
//                   </div>
//                   <button onClick={() => setDetailOpen(false)} className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200">
//                     <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" /></svg>
//                   </button>
//                 </div>
//                 <div className="px-4 py-3 space-y-3">
//                   <div className="grid grid-cols-2 gap-2">
//                     <div>
//                       <p className="text-xs text-gray-400">Pick up date</p>
//                       <p className="text-xs font-semibold text-gray-700">{detail?.pickupDate || "-"}</p>
//                     </div>
//                     <div>
//                       <p className="text-xs text-gray-400">Delivery date</p>
//                       <p className="text-xs font-semibold text-gray-700">{detail?.deliveryDate || "-"}</p>
//                     </div>
//                   </div>
//                   <div className="space-y-2">
//                     <div className="flex items-start gap-2">
//                       <div className="mt-1 w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
//                       <div>
//                         <p className="text-xs text-gray-400">Pick up location</p>
//                         <p className="text-xs font-medium text-gray-700">{detail?.pickupLocation || "-"}</p>
//                       </div>
//                     </div>
//                     <div className="flex items-start gap-2">
//                       <div className="mt-1 w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />
//                       <div>
//                         <p className="text-xs text-gray-400">Delivery location</p>
//                         <p className="text-xs font-medium text-gray-700">{detail?.deliveryLocation || "-"}</p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="border-t border-gray-50 pt-2 space-y-2">
//                     {[
//                       { label: "Driver", value: detail?.driver || "-", icon: "👤" },
//                       { label: "Truck", value: detail?.truck || "-", icon: "🚛" },
//                       { label: "Traveled", value: detail?.traveled || "-", icon: "📍" },
//                       { label: "Speed", value: detail?.speed || "-", icon: "⚡" },
//                     ].map((item) => (
//                       <div key={item.label} className="flex items-center justify-between">
//                         <p className="text-xs text-gray-400">{item.label}</p>
//                         <p className="text-xs font-semibold text-gray-700 flex items-center gap-1">
//                           {item.value} <span>{item.icon}</span>
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                   <div className="pt-2">
//                     <button
//                       onClick={downloadInvoicePdf}
//                       disabled={!selectedLoadId || downloadingInvoice}
//                       className="w-full text-xs px-2 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60"
//                     >
//                       {downloadingInvoice ? "Downloading..." : "Download Invoice"}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Desktop detail panel */}
//           {showDetail && (
//             <div className="absolute top-4 left-4 w-11/12 max-w-sm md:w-64 md:max-w-xs bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden z-10 hidden md:block">
//               <div className="flex items-center justify-between px-4 py-3 border-b border-gray-50">
//                 <div>
//                   <p className="text-xs text-gray-400">Load id:</p>
//                   <p className="text-sm font-bold text-gray-900">{detail?.id || "-"}</p>
//                 </div>
//                 <button onClick={() => setShowDetail(false)} className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200">
//                   <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" /></svg>
//                 </button>
//               </div>
//               <div className="px-4 py-3 space-y-3">
//                 <div className="grid grid-cols-2 gap-2">
//                   <div>
//                     <p className="text-xs text-gray-400">Pick up date</p>
//                     <p className="text-xs font-semibold text-gray-700">{detail?.pickupDate || "-"}</p>
//                   </div>
//                   <div>
//                     <p className="text-xs text-gray-400">Delivery date</p>
//                     <p className="text-xs font-semibold text-gray-700">{detail?.deliveryDate || "-"}</p>
//                   </div>
//                 </div>
//                 <div className="space-y-2">
//                   <div className="flex items-start gap-2">
//                     <div className="mt-1 w-2 h-2 rounded-full bg-blue-500 flex-shrink-0" />
//                     <div>
//                       <p className="text-xs text-gray-400">Pick up location</p>
//                       <p className="text-xs font-medium text-gray-700">{detail?.pickupLocation || "-"}</p>
//                     </div>
//                   </div>
//                   <div className="flex items-start gap-2">
//                     <div className="mt-1 w-2 h-2 rounded-full bg-red-500 flex-shrink-0" />
//                     <div>
//                       <p className="text-xs text-gray-400">Delivery location</p>
//                       <p className="text-xs font-medium text-gray-700">{detail?.deliveryLocation || "-"}</p>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="border-t border-gray-50 pt-2 space-y-2">
//                   {[
//                     { label: "Driver", value: detail?.driver || "-", icon: "👤" },
//                     { label: "Truck", value: detail?.truck || "-", icon: "🚛" },
//                     { label: "Traveled", value: detail?.traveled || "-", icon: "📍" },
//                     { label: "Speed", value: detail?.speed || "-", icon: "⚡" },
//                   ].map((item) => (
//                     <div key={item.label} className="flex items-center justify-between">
//                       <p className="text-xs text-gray-400">{item.label}</p>
//                       <p className="text-xs font-semibold text-gray-700 flex items-center gap-1">
//                         {item.value} <span>{item.icon}</span>
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="pt-2">
//                   <button
//                     onClick={downloadInvoicePdf}
//                     disabled={!selectedLoadId || downloadingInvoice}
//                     className="w-full text-xs px-2 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60"
//                   >
//                     {downloadingInvoice ? "Downloading..." : "Download Invoice"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           <div className="absolute bottom-4 right-4 bg-white rounded-2xl shadow-xl border border-gray-100 p-4 w-48 z-10 hidden sm:block">
//             <p className="text-xs font-semibold text-gray-500 mb-1">Week Overview</p>
//             <p className="text-3xl font-bold text-blue-600">5,000</p>
//             <div className="mt-2 h-10 flex items-end gap-1">
//               {[40, 60, 35, 80, 55, 70, 45].map((h, i) => (
//                 <div key={i} className="flex-1 rounded-sm bg-blue-100" style={{ height: `${h}%` }}>
//                   <div className="w-full rounded-sm bg-blue-500" style={{ height: i === 3 ? "100%" : "40%" }} />
//                 </div>
//               ))}
//             </div>
//           </div>
//           {/* Mobile summary widget */}
//           <div className="absolute bottom-2 left-2 right-2 sm:hidden">
//             <div className="bg-white rounded-xl shadow-md border border-gray-100 p-3 flex flex-col items-center min-w-0">
//               <p className="text-xs font-semibold text-gray-500 mb-1">Week Overview</p>
//               <p className="text-3xl font-bold text-blue-600">5,000</p>
//               <div className="w-full mt-2 h-8 flex items-end gap-1">
//                 {[40, 60, 35, 80, 55, 70, 45].map((h, i) => (
//                   <div key={i} className="flex-1 rounded-sm bg-blue-100" style={{ height: `${h}%` }}>
//                     <div className="w-full rounded-sm bg-blue-500" style={{ height: i === 3 ? "100%" : "40%" }} />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;

// import { useEffect, useMemo, useState, useCallback } from "react";

// /* ============================================================
//    Types — mapped to your actual backend API responses
//    ============================================================ */

// type ApiStatus = "pending" | "booked" | "in_transit" | "delivered" | "cancelled";
// type UiStatus = "Pending" | "Booked" | "In-transit" | "Delivered" | "Cancelled";

// interface ConsignmentRow {
//   id: number;
//   lr_number: string;
//   consignor_id: number;
//   receiver_id: number;
//   transporter_id: number | null;
//   driver_id: number | null;
//   vehicle_id: number | null;
//   status: ApiStatus;
//   pickup_address: string;
//   delivery_address: string;
//   pickup_date: string;
//   delivery_date: string | null;
//   payment_mode: string;
//   notes: string | null;
//   total_amount: number;
//   created_at?: string;
// }

// interface ConsignmentItem {
//   id: number;
//   consignment_id: number;
//   item_name: string;
//   item_type: string;
//   quantity: number;
//   unit: string;
//   weight_kg: number;
//   declared_value: number | null;
//   is_insured: number;
//   special_handling: string | null;
// }

// interface ChargeRow {
//   id: number;
//   consignment_id: number;
//   charge_type: string;
//   amount: number;
//   description: string | null;
//   paid_by: string;
//   is_paid: number;
//   paid_at: string | null;
// }

// interface TrackingEvent {
//   id: number;
//   consignment_id: number;
//   event_type: string;
//   location: string;
//   latitude: number | null;
//   longitude: number | null;
//   notes: string | null;
//   recorded_by: number | null;
//   event_time: string;
// }

// interface ConsignmentDetail extends ConsignmentRow {
//   items: ConsignmentItem[];
//   charges: ChargeRow[];
// }

// /* ============================================================
//    Helpers
//    ============================================================ */

// const API = (): string => process.env.REACT_APP_API_URL || "";

// const statusMeta: Record<UiStatus, { dot: string; chip: string; bar: string }> = {
//   Pending: { dot: "bg-amber-400", chip: "bg-amber-50 text-amber-600 border-amber-200", bar: "bg-amber-400" },
//   Booked: { dot: "bg-violet-400", chip: "bg-violet-50 text-violet-600 border-violet-200", bar: "bg-violet-400" },
//   "In-transit": { dot: "bg-blue-400", chip: "bg-blue-50 text-blue-600 border-blue-200", bar: "bg-blue-500" },
//   Delivered: { dot: "bg-emerald-400", chip: "bg-emerald-50 text-emerald-600 border-emerald-200", bar: "bg-emerald-500" },
//   Cancelled: { dot: "bg-rose-400", chip: "bg-rose-50 text-rose-600 border-rose-200", bar: "bg-rose-400" },
// };

// const toUiStatus = (s: ApiStatus): UiStatus => {
//   switch (s) {
//     case "delivered": return "Delivered";
//     case "in_transit": return "In-transit";
//     case "booked": return "Booked";
//     case "cancelled": return "Cancelled";
//     default: return "Pending";
//   }
// };

// const progressForStatus = (s: UiStatus): number => {
//   switch (s) {
//     case "Delivered": return 100;
//     case "In-transit": return 65;
//     case "Booked": return 35;
//     case "Pending": return 15;
//     case "Cancelled": return 0;
//   }
// };

// const formatDate = (v?: string | null): string => {
//   if (!v) return "—";
//   const d = new Date(v);
//   return Number.isNaN(d.getTime())
//     ? "—"
//     : d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// };

// const formatDateTime = (v?: string | null): string => {
//   if (!v) return "—";
//   const d = new Date(v);
//   return Number.isNaN(d.getTime())
//     ? "—"
//     : d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
// };

// const inr = (n: number): string =>
//   new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

// const initials = (v: string): string => {
//   const s = String(v || "").replace(/\s+/g, " ").trim();
//   if (!s) return "NA";
//   const p = s.split(" ").filter(Boolean);
//   return `${p[0]?.[0] ?? "N"}${(p.length > 1 ? p[p.length - 1]?.[0] : p[0]?.[1]) ?? ""}`.toUpperCase();
// };

// /* ============================================================
//    Small UI atoms
//    ============================================================ */

// const Spinner = ({ size = 16 }: { size?: number }) => (
//   <svg className="animate-spin" width={size} height={size} viewBox="0 0 24 24" fill="none">
//     <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-20" />
//     <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
//   </svg>
// );

// const StatusChip = ({ status }: { status: UiStatus }) => (
//   <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${statusMeta[status].chip}`}>
//     <span className={`w-1.5 h-1.5 rounded-full ${statusMeta[status].dot}`} />
//     {status}
//   </span>
// );

// /* ============================================================
//    Main Component
//    ============================================================ */

// const TABS: { label: string; match: (s: UiStatus) => boolean }[] = [
//   { label: "All", match: () => true },
//   { label: "In-transit", match: (s) => s === "In-transit" },
//   { label: "Pending", match: (s) => s === "Pending" || s === "Booked" },
//   { label: "Delivered", match: (s) => s === "Delivered" },
// ];

// const AdminDashboard = () => {
//   const [rows, setRows] = useState<ConsignmentRow[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   const [activeTab, setActiveTab] = useState("All");
//   const [search, setSearch] = useState("");

//   const [selectedId, setSelectedId] = useState<number | null>(null);
//   const [detail, setDetail] = useState<ConsignmentDetail | null>(null);
//   const [tracking, setTracking] = useState<TrackingEvent[]>([]);
//   const [detailLoading, setDetailLoading] = useState(false);

//   const [downloading, setDownloading] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [detailOpen, setDetailOpen] = useState(false);

//   /* ---------- Fetch consignments list ---------- */
//   useEffect(() => {
//     const apiUrl = API();
//     if (!apiUrl) {
//       setLoading(false);
//       setError("API URL is not configured.");
//       return;
//     }

//     let mounted = true;
//     (async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(`${apiUrl}/auth/consignments`);
//         if (!res.ok) throw new Error("Failed to fetch consignments");
//         const data = (await res.json()) as ConsignmentRow[];
//         if (!mounted) return;
//         const sorted = [...data].sort((a, b) => b.id - a.id);
//         setRows(sorted);
//         if (sorted.length > 0) setSelectedId(sorted[0].id);
//         setError(null);
//       } catch {
//         if (mounted) setError("Could not load consignments from the server.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => { mounted = false; };
//   }, []);

//   /* ---------- Fetch detail + tracking when selected ---------- */
//   useEffect(() => {
//     const apiUrl = API();
//     if (!selectedId || !apiUrl) return;

//     let mounted = true;
//     (async () => {
//       try {
//         setDetailLoading(true);
//         const [dRes, tRes] = await Promise.all([
//           fetch(`${apiUrl}/auth/consignments/${selectedId}`),
//           fetch(`${apiUrl}/auth/consignments/${selectedId}/tracking`).catch(() => null),
//         ]);

//         if (dRes.ok && mounted) {
//           const d = (await dRes.json()) as ConsignmentDetail;
//           setDetail(d);
//         }
//         if (tRes && tRes.ok && mounted) {
//           const t = (await tRes.json()) as TrackingEvent[];
//           setTracking(Array.isArray(t) ? t : []);
//         } else if (mounted) {
//           setTracking([]);
//         }
//       } catch {
//         /* keep stale detail */
//       } finally {
//         if (mounted) setDetailLoading(false);
//       }
//     })();
//     return () => { mounted = false; };
//   }, [selectedId]);

//   /* ---------- Responsive cleanup ---------- */
//   useEffect(() => {
//     const onResize = () => {
//       if (window.innerWidth >= 1024) {
//         setSidebarOpen(false);
//         setDetailOpen(false);
//       }
//     };
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   /* ---------- Derived data ---------- */
//   const enriched = useMemo(
//     () => rows.map((r) => ({ ...r, ui: toUiStatus(r.status) })),
//     [rows]
//   );

//   const filtered = useMemo(() => {
//     const tab = TABS.find((t) => t.label === activeTab) ?? TABS[0];
//     const q = search.trim().toLowerCase();
//     return enriched.filter((r) => {
//       if (!tab.match(r.ui)) return false;
//       if (!q) return true;
//       return (
//         r.lr_number?.toLowerCase().includes(q) ||
//         String(r.id).includes(q) ||
//         r.pickup_address?.toLowerCase().includes(q) ||
//         r.delivery_address?.toLowerCase().includes(q)
//       );
//     });
//   }, [enriched, activeTab, search]);

//   const stats = useMemo(() => {
//     const total = enriched.length;
//     const inTransit = enriched.filter((r) => r.ui === "In-transit").length;
//     const delivered = enriched.filter((r) => r.ui === "Delivered").length;
//     const pending = enriched.filter((r) => r.ui === "Pending" || r.ui === "Booked").length;
//     const revenue = enriched.reduce((s, r) => s + Number(r.total_amount || 0), 0);
//     const onTime = total ? ((delivered / total) * 100).toFixed(0) : "0";
//     return { total, inTransit, delivered, pending, revenue, onTime };
//   }, [enriched]);

//   const tabCounts = useMemo(() => {
//     return TABS.map((t) => ({
//       label: t.label,
//       count: enriched.filter((r) => t.match(r.ui)).length,
//     }));
//   }, [enriched]);

//   /* ---------- Detail computed values ---------- */
//   const detailTotals = useMemo(() => {
//     if (!detail) return { weight: 0, items: 0, charges: 0, paidCharges: 0, declared: 0 };
//     const weight = (detail.items || []).reduce((s, i) => s + Number(i.weight_kg || 0), 0);
//     const declared = (detail.items || []).reduce((s, i) => s + Number(i.declared_value || 0), 0);
//     const charges = (detail.charges || []).reduce((s, c) => s + Number(c.amount || 0), 0);
//     const paidCharges = (detail.charges || [])
//       .filter((c) => c.is_paid)
//       .reduce((s, c) => s + Number(c.amount || 0), 0);
//     return { weight, items: (detail.items || []).length, charges, paidCharges, declared };
//   }, [detail]);

//   /* ---------- Actions ---------- */
//   const selectLoad = useCallback((id: number) => {
//     setSelectedId(id);
//     if (window.innerWidth < 1024) {
//       setSidebarOpen(false);
//       setDetailOpen(true);
//     }
//   }, []);

//   const downloadInvoice = useCallback(async () => {
//     const apiUrl = API();
//     if (!apiUrl || !selectedId) return;
//     try {
//       setDownloading(true);
//       const res = await fetch(`${apiUrl}/auth/consignments/${selectedId}/invoice/pdf`);
//       if (!res.ok) throw new Error("download failed");
//       const blob = await res.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `invoice-${detail?.lr_number || selectedId}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch {
//       /* silent */
//     } finally {
//       setDownloading(false);
//     }
//   }, [selectedId, detail]);

//   const detailUi = detail ? toUiStatus(detail.status) : "Pending";

//   /* ============================================================
//      Render
//      ============================================================ */
//   return (
//     <div className="flex flex-col lg:flex-row h-full min-h-[700px] bg-slate-50 font-sans text-slate-800 relative">
//       {/* ---------------- Mobile top bar ---------------- */}
//       <div className="lg:hidden flex items-center justify-between px-4 h-14 bg-white border-b border-slate-100 sticky top-0 z-20">
//         <button
//           onClick={() => setSidebarOpen(true)}
//           className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center"
//           aria-label="Open menu"
//         >
//           <svg width="20" height="20" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//             <path d="M4 7h16M4 12h16M4 17h16" />
//           </svg>
//         </button>
//         <h1 className="text-base font-bold text-slate-900">Consignments</h1>
//         <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center text-white text-xs font-bold">
//           AD
//         </div>
//       </div>

//       {/* ================= SIDEBAR ================= */}
//       <aside
//         className={`fixed lg:static inset-y-0 left-0 z-40 w-[88%] max-w-sm lg:w-[360px]
//           bg-white border-r border-slate-100 flex flex-col shrink-0
//           transition-transform duration-300
//           ${sidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"} lg:translate-x-0`}
//       >
//         {/* Header */}
//         <div className="px-5 pt-5 pb-3">
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <h1 className="text-lg font-bold text-slate-900 tracking-tight">Tracking Loads</h1>
//               <p className="text-xs text-slate-400">{stats.total} total consignments</p>
//             </div>
//             <div className="hidden lg:flex items-center gap-2">
//               <button className="w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition">
//                 <svg width="16" height="16" fill="#475569" viewBox="0 0 24 24">
//                   <path d="M12 22c1.1 0 2-.9 2-2H10c0 1.1.9 2 2 2zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
//                 </svg>
//               </button>
//               <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center text-white text-xs font-bold">
//                 AD
//               </div>
//             </div>
//             <button
//               onClick={() => setSidebarOpen(false)}
//               className="lg:hidden w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center"
//             >
//               <svg width="14" height="14" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M18 6L6 18M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           {/* Search */}
//           <div className="relative">
//             <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//               <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
//             </svg>
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search LR number, route…"
//               className="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 placeholder-slate-400 transition"
//             />
//           </div>
//         </div>

//         {/* Tabs */}
//         <div className="flex gap-1.5 px-5 pb-3 overflow-x-auto no-scrollbar">
//           {tabCounts.map((tab) => (
//             <button
//               key={tab.label}
//               onClick={() => setActiveTab(tab.label)}
//               className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition ${
//                 activeTab === tab.label
//                   ? "bg-slate-900 text-white shadow-sm"
//                   : "text-slate-500 bg-slate-50 hover:bg-slate-100"
//               }`}
//             >
//               {tab.label}
//               <span className={`text-[10px] rounded-full px-1.5 py-px ${activeTab === tab.label ? "bg-white/20" : "bg-slate-200 text-slate-600"}`}>
//                 {tab.count}
//               </span>
//             </button>
//           ))}
//         </div>

//         {/* List */}
//         <div className="flex-1 overflow-y-auto px-3 pb-4 space-y-2">
//           {loading && (
//             <div className="flex flex-col items-center justify-center py-16 text-slate-400 gap-3">
//               <Spinner size={22} />
//               <span className="text-xs">Loading consignments…</span>
//             </div>
//           )}

//           {error && !loading && (
//             <div className="mx-2 mt-4 p-4 rounded-xl bg-rose-50 border border-rose-100 text-rose-600 text-xs">
//               {error}
//             </div>
//           )}

//           {!loading && !error && filtered.length === 0 && (
//             <div className="flex flex-col items-center justify-center py-16 text-slate-400 gap-2">
//               <svg width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
//                 <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//                 <path d="m3.27 6.96 8.73 5.05 8.73-5.05M12 22.08V12" />
//               </svg>
//               <span className="text-xs">No consignments found</span>
//             </div>
//           )}

//           {!loading && !error && filtered.map((load) => {
//             const isActive = selectedId === load.id;
//             const progress = progressForStatus(load.ui);
//             return (
//               <button
//                 key={load.id}
//                 onClick={() => selectLoad(load.id)}
//                 className={`w-full text-left p-3.5 rounded-2xl border transition-all duration-200 ${
//                   isActive
//                     ? "border-indigo-200 bg-indigo-50/60 shadow-sm ring-1 ring-indigo-100"
//                     : "border-slate-100 bg-white hover:border-slate-200 hover:shadow-sm"
//                 }`}
//               >
//                 <div className="flex items-start justify-between mb-2.5">
//                   <div className="min-w-0">
//                     <p className="text-sm font-semibold text-slate-900 truncate">{load.lr_number || `Consignment #${load.id}`}</p>
//                     <p className="text-[11px] text-slate-400">ID #{load.id} · {load.payment_mode || "—"}</p>
//                   </div>
//                   <StatusChip status={load.ui} />
//                 </div>

//                 {/* Route */}
//                 <div className="flex items-center gap-2 text-[11px] text-slate-500 mb-2">
//                   <span className="font-medium">{formatDate(load.pickup_date)}</span>
//                   <div className="flex-1 flex items-center gap-1">
//                     <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 shrink-0" />
//                     <div className="flex-1 border-t border-dashed border-slate-300" />
//                     <svg width="12" height="12" fill="#94a3b8" viewBox="0 0 24 24">
//                       <path d="M17 8C8 10 5.9 16.17 3.82 21L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20c4 0 4-2 8-2s4 2 8 2v-2c-4 0-4-2-8-2c-1.13 0-1.9.16-2.53.33C14.28 12.07 16 9.66 17 8z" />
//                     </svg>
//                     <div className="w-1.5 h-1.5 rounded-full bg-rose-400 shrink-0" />
//                   </div>
//                   <span className="font-medium">{formatDate(load.delivery_date)}</span>
//                 </div>

//                 <div className="flex justify-between text-[11px] text-slate-400 gap-2 mb-2.5">
//                   <span className="truncate max-w-[45%]" title={load.pickup_address}>{load.pickup_address || "—"}</span>
//                   <span className="truncate max-w-[45%] text-right" title={load.delivery_address}>{load.delivery_address || "—"}</span>
//                 </div>

//                 {/* Footer: avatars + amount + progress */}
//                 <div className="flex items-center justify-between">
//                   <div className="flex -space-x-1.5">
//                     <div className="w-6 h-6 rounded-full bg-slate-900 text-white flex items-center justify-center text-[9px] font-bold ring-2 ring-white" title="Consignor">
//                       {initials(load.pickup_address)}
//                     </div>
//                     <div className="w-6 h-6 rounded-full bg-white border border-slate-300 text-slate-700 flex items-center justify-center text-[9px] font-bold ring-2 ring-white" title="Receiver">
//                       {initials(load.delivery_address)}
//                     </div>
//                   </div>
//                   <span className="text-xs font-bold text-slate-700">{inr(load.total_amount)}</span>
//                 </div>

//                 <div className="mt-2.5 w-full h-1.5 rounded-full bg-slate-100 overflow-hidden">
//                   <div
//                     className={`h-full rounded-full transition-all duration-500 ${statusMeta[load.ui].bar}`}
//                     style={{ width: `${progress}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </div>
//       </aside>

//       {/* Sidebar overlay (mobile) */}
//       {sidebarOpen && (
//         <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
//       )}

//       {/* ================= MAIN ================= */}
//       <main className="flex-1 flex flex-col overflow-hidden">
//         {/* Stat cards */}
//         <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4 p-4 md:p-5 md:pb-0">
//           {[
//             { label: "Active Loads", value: String(stats.inTransit), sub: "in-transit now", icon: "🚛", grad: "from-blue-500 to-indigo-500" },
//             { label: "Delivered", value: String(stats.delivered), sub: `${stats.onTime}% completion`, icon: "📦", grad: "from-emerald-500 to-teal-500" },
//             { label: "Pending", value: String(stats.pending), sub: "awaiting dispatch", icon: "⏳", grad: "from-amber-500 to-orange-500" },
//             { label: "Total Revenue", value: inr(stats.revenue), sub: `${stats.total} consignments`, icon: "💰", grad: "from-violet-500 to-purple-500" },
//           ].map((s) => (
//             <div key={s.label} className="rounded-2xl bg-white border border-slate-100 p-4 shadow-sm hover:shadow-md transition-shadow">
//               <div className="flex items-start justify-between mb-3">
//                 <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${s.grad} flex items-center justify-center text-lg shadow-sm`}>
//                   {s.icon}
//                 </div>
//               </div>
//               <p className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight truncate">{s.value}</p>
//               <p className="text-xs font-medium text-slate-500 mt-0.5">{s.label}</p>
//               <p className="text-[11px] text-slate-400">{s.sub}</p>
//             </div>
//           ))}
//         </div>

//         {/* Detail content area */}
//         <div className="flex-1 overflow-y-auto p-4 md:p-5">
//           {!selectedId && !loading && (
//             <div className="h-full min-h-[300px] flex flex-col items-center justify-center text-slate-400 gap-3">
//               <svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
//                 <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
//               </svg>
//               <p className="text-sm">Select a consignment to view details</p>
//             </div>
//           )}

//           {selectedId && (
//             <div className="hidden lg:grid grid-cols-1 xl:grid-cols-3 gap-5">
//               {/* Left: Overview + Items + Charges */}
//               <div className="xl:col-span-2 space-y-5">
//                 <DetailHeader
//                   detail={detail}
//                   ui={detailUi}
//                   loading={detailLoading}
//                   totals={detailTotals}
//                   downloading={downloading}
//                   onDownload={downloadInvoice}
//                 />
//                 <ItemsCard items={detail?.items || []} loading={detailLoading} totalWeight={detailTotals.weight} />
//                 <ChargesCard charges={detail?.charges || []} loading={detailLoading} total={detailTotals.charges} paid={detailTotals.paidCharges} />
//               </div>

//               {/* Right: Route + Tracking timeline */}
//               <div className="space-y-5">
//                 <RouteCard detail={detail} />
//                 <TrackingCard events={tracking} loading={detailLoading} />
//               </div>
//             </div>
//           )}
//         </div>
//       </main>

//       {/* ================= MOBILE DETAIL DRAWER ================= */}
//       {detailOpen && (
//         <div className="fixed inset-0 z-50 lg:hidden flex">
//           <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setDetailOpen(false)} />
//           <div className="relative ml-auto w-full max-w-md h-full bg-slate-50 overflow-y-auto animate-[slideIn_.25s_ease]">
//             <div className="sticky top-0 z-10 flex items-center justify-between px-4 h-14 bg-white border-b border-slate-100">
//               <p className="text-sm font-bold text-slate-900">{detail?.lr_number || `Consignment #${selectedId}`}</p>
//               <button onClick={() => setDetailOpen(false)} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center">
//                 <svg width="14" height="14" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//                   <path d="M18 6L6 18M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//             <div className="p-4 space-y-4">
//               <DetailHeader detail={detail} ui={detailUi} loading={detailLoading} totals={detailTotals} downloading={downloading} onDownload={downloadInvoice} />
//               <RouteCard detail={detail} />
//               <ItemsCard items={detail?.items || []} loading={detailLoading} totalWeight={detailTotals.weight} />
//               <ChargesCard charges={detail?.charges || []} loading={detailLoading} total={detailTotals.charges} paid={detailTotals.paidCharges} />
//               <TrackingCard events={tracking} loading={detailLoading} />
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
//         .no-scrollbar::-webkit-scrollbar { display: none; }
//         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
//       `}</style>
//     </div>
//   );
// };

// /* ============================================================
//    Sub-components
//    ============================================================ */

// const DetailHeader = ({
//   detail, ui, loading, totals, downloading, onDownload,
// }: {
//   detail: ConsignmentDetail | null;
//   ui: UiStatus;
//   loading: boolean;
//   totals: { weight: number; items: number; charges: number; declared: number };
//   downloading: boolean;
//   onDownload: () => void;
// }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm overflow-hidden">
//     <div className="p-5 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
//       <div className="flex items-start justify-between gap-3">
//         <div className="min-w-0">
//           <p className="text-[11px] uppercase tracking-widest text-slate-400 mb-1">LR Number</p>
//           <h2 className="text-xl font-bold truncate">{detail?.lr_number || "—"}</h2>
//           <p className="text-xs text-slate-400 mt-1">Consignment ID #{detail?.id ?? "—"}</p>
//         </div>
//         <StatusChip status={ui} />
//       </div>

//       <div className="grid grid-cols-3 gap-3 mt-5">
//         {[
//           { k: "Items", v: loading ? "…" : String(totals.items) },
//           { k: "Weight", v: loading ? "…" : `${totals.weight.toFixed(0)} kg` },
//           { k: "Amount", v: loading ? "…" : inr(detail?.total_amount || totals.charges) },
//         ].map((m) => (
//           <div key={m.k} className="rounded-xl bg-white/10 backdrop-blur px-3 py-2.5">
//             <p className="text-[10px] uppercase tracking-wide text-slate-400">{m.k}</p>
//             <p className="text-base font-bold truncate">{m.v}</p>
//           </div>
//         ))}
//       </div>
//     </div>

//     <div className="p-4 flex flex-wrap items-center gap-3">
//       <div className="flex items-center gap-2 text-xs text-slate-500">
//         <span className="font-medium text-slate-700">Payment:</span>
//         <span className="px-2 py-0.5 rounded-md bg-slate-100 capitalize">{detail?.payment_mode || "—"}</span>
//       </div>
//       <div className="flex items-center gap-2 text-xs text-slate-500">
//         <span className="font-medium text-slate-700">Declared:</span>
//         <span>{inr(totals.declared)}</span>
//       </div>
//       <button
//         onClick={onDownload}
//         disabled={!detail || downloading}
//         className="ml-auto inline-flex items-center gap-2 text-xs font-semibold px-4 py-2.5 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 transition"
//       >
//         {downloading ? <Spinner size={14} /> : (
//           <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
//           </svg>
//         )}
//         {downloading ? "Downloading…" : "Download Invoice"}
//       </button>
//     </div>

//     {detail?.notes && (
//       <div className="px-4 pb-4">
//         <div className="rounded-xl bg-amber-50 border border-amber-100 px-3 py-2 text-xs text-amber-700">
//           <span className="font-semibold">Note: </span>{detail.notes}
//         </div>
//       </div>
//     )}
//   </div>
// );

// const RouteCard = ({ detail }: { detail: ConsignmentDetail | null }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2">
//       <svg width="16" height="16" fill="none" stroke="#6366f1" strokeWidth="2" viewBox="0 0 24 24">
//         <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
//       </svg>
//       Route
//     </h3>
//     <div className="relative pl-6">
//       <div className="absolute left-[7px] top-3 bottom-3 w-0.5 bg-gradient-to-b from-indigo-300 to-rose-300" />
//       <div className="relative mb-5">
//         <div className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-indigo-500 ring-4 ring-indigo-100" />
//         <p className="text-[11px] uppercase tracking-wide text-slate-400">Pickup</p>
//         <p className="text-sm font-medium text-slate-800">{detail?.pickup_address || "—"}</p>
//         <p className="text-xs text-slate-400 mt-0.5">{formatDate(detail?.pickup_date)}</p>
//       </div>
//       <div className="relative">
//         <div className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-rose-500 ring-4 ring-rose-100" />
//         <p className="text-[11px] uppercase tracking-wide text-slate-400">Delivery</p>
//         <p className="text-sm font-medium text-slate-800">{detail?.delivery_address || "—"}</p>
//         <p className="text-xs text-slate-400 mt-0.5">{formatDate(detail?.delivery_date)}</p>
//       </div>
//     </div>
//   </div>
// );

// const ItemsCard = ({ items, loading, totalWeight }: { items: ConsignmentItem[]; loading: boolean; totalWeight: number }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <div className="flex items-center justify-between mb-4">
//       <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
//         <svg width="16" height="16" fill="none" stroke="#0ea5e9" strokeWidth="2" viewBox="0 0 24 24">
//           <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//         </svg>
//         Items
//         <span className="text-[11px] font-semibold text-slate-400">({items.length})</span>
//       </h3>
//       <span className="text-xs font-semibold text-slate-500">{totalWeight.toFixed(1)} kg total</span>
//     </div>

//     {loading ? (
//       <div className="py-6 flex justify-center text-slate-300"><Spinner size={18} /></div>
//     ) : items.length === 0 ? (
//       <p className="text-xs text-slate-400 py-4 text-center">No items recorded</p>
//     ) : (
//       <div className="space-y-2">
//         {items.map((it) => (
//           <div key={it.id} className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 border border-slate-100">
//             <div className="w-9 h-9 rounded-lg bg-sky-100 text-sky-600 flex items-center justify-center text-xs font-bold shrink-0">
//               {initials(it.item_name)}
//             </div>
//             <div className="min-w-0 flex-1">
//               <div className="flex items-center gap-2">
//                 <p className="text-sm font-semibold text-slate-800 truncate">{it.item_name}</p>
//                 {it.is_insured ? (
//                   <span className="text-[9px] font-bold px-1.5 py-px rounded bg-emerald-100 text-emerald-600">INSURED</span>
//                 ) : null}
//               </div>
//               <p className="text-[11px] text-slate-400 capitalize">
//                 {it.item_type} · {it.quantity} {it.unit}
//                 {it.special_handling ? ` · ${it.special_handling}` : ""}
//               </p>
//             </div>
//             <div className="text-right shrink-0">
//               <p className="text-sm font-bold text-slate-700">{Number(it.weight_kg).toFixed(0)} kg</p>
//               {it.declared_value ? <p className="text-[11px] text-slate-400">{inr(it.declared_value)}</p> : null}
//             </div>
//           </div>
//         ))}
//       </div>
//     )}
//   </div>
// );

// const ChargesCard = ({
//   charges, loading, total, paid,
// }: { charges: ChargeRow[]; loading: boolean; total: number; paid: number }) => {
//   const pending = total - paid;
//   return (
//     <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//       <div className="flex items-center justify-between mb-4">
//         <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
//           <svg width="16" height="16" fill="none" stroke="#8b5cf6" strokeWidth="2" viewBox="0 0 24 24">
//             <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
//           </svg>
//           Charges
//           <span className="text-[11px] font-semibold text-slate-400">({charges.length})</span>
//         </h3>
//         <span className="text-sm font-bold text-slate-900">{inr(total)}</span>
//       </div>

//       {loading ? (
//         <div className="py-6 flex justify-center text-slate-300"><Spinner size={18} /></div>
//       ) : charges.length === 0 ? (
//         <p className="text-xs text-slate-400 py-4 text-center">No charges recorded</p>
//       ) : (
//         <>
//           <div className="space-y-1.5 mb-4">
//             {charges.map((c) => (
//               <div key={c.id} className="flex items-center justify-between p-2.5 rounded-lg hover:bg-slate-50 transition">
//                 <div className="flex items-center gap-2.5 min-w-0">
//                   <span className={`w-2 h-2 rounded-full shrink-0 ${c.is_paid ? "bg-emerald-400" : "bg-amber-400"}`} />
//                   <div className="min-w-0">
//                     <p className="text-sm font-medium text-slate-700 capitalize truncate">{c.charge_type}</p>
//                     <p className="text-[11px] text-slate-400 capitalize">Paid by {c.paid_by}{c.description ? ` · ${c.description}` : ""}</p>
//                   </div>
//                 </div>
//                 <div className="text-right shrink-0">
//                   <p className="text-sm font-semibold text-slate-700">{inr(c.amount)}</p>
//                   <p className={`text-[10px] font-bold ${c.is_paid ? "text-emerald-500" : "text-amber-500"}`}>
//                     {c.is_paid ? "PAID" : "PENDING"}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="grid grid-cols-2 gap-3 pt-3 border-t border-slate-100">
//             <div className="rounded-xl bg-emerald-50 p-3">
//               <p className="text-[11px] text-emerald-600 font-medium">Paid</p>
//               <p className="text-base font-bold text-emerald-700">{inr(paid)}</p>
//             </div>
//             <div className="rounded-xl bg-amber-50 p-3">
//               <p className="text-[11px] text-amber-600 font-medium">Outstanding</p>
//               <p className="text-base font-bold text-amber-700">{inr(pending)}</p>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// const TrackingCard = ({ events, loading }: { events: TrackingEvent[]; loading: boolean }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2">
//       <svg width="16" height="16" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24">
//         <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
//       </svg>
//       Tracking Timeline
//     </h3>

//     {loading ? (
//       <div className="py-6 flex justify-center text-slate-300"><Spinner size={18} /></div>
//     ) : events.length === 0 ? (
//       <p className="text-xs text-slate-400 py-4 text-center">No tracking events yet</p>
//     ) : (
//       <div className="relative pl-6 space-y-5">
//         <div className="absolute left-[7px] top-2 bottom-2 w-0.5 bg-slate-100" />
//         {events.map((e, i) => (
//           <div key={e.id} className="relative">
//             <div className={`absolute -left-6 top-1 w-3.5 h-3.5 rounded-full ring-4 ${i === 0 ? "bg-emerald-500 ring-emerald-100" : "bg-slate-300 ring-slate-100"}`} />
//             <div className="flex items-center justify-between gap-2">
//               <p className="text-sm font-semibold text-slate-800 capitalize">{e.event_type?.replace(/_/g, " ")}</p>
//               <span className="text-[11px] text-slate-400 shrink-0">{formatDateTime(e.event_time)}</span>
//             </div>
//             <p className="text-xs text-slate-500 mt-0.5">{e.location}</p>
//             {e.notes && <p className="text-[11px] text-slate-400 mt-0.5 italic">{e.notes}</p>}
//           </div>
//         ))}
//       </div>
//     )}
//   </div>
// );

// export default AdminDashboard;


// import { useEffect, useMemo, useState, useCallback } from "react";

// /* ============================================================
//    Types — mapped to the invoice / invoice_items / settlement APIs
//    (mounted as /invoiceapi/* and /settlment/* in your server)
//    ============================================================ */

// // Raw shape returned by GET /invoiceapi/invoice and /invoiceapi/invoice/:id.
// // Note the literal "InvoiceNo." key — that's the real column name in MySQL.
// interface RawInvoiceRow {
//   id: number;
//   company: string;
//   sender: string | null;
//   receiver: string | null;
//   broker: string | null;
//   transporter: string | null;
//   driver: string | null;
//   vehicles: string | null;
//   payment: string | null;
//   source: string | null;
//   destination: string | null;
//   receiverAmountStatatus: string | null;
//   senderAmountStatatus: string | null;
//   transporterAmountStatatus: string | null;
//   paymentStatus: string | null;
//   paymentPayableConsignor: string | null;
//   ItemsDescription: string | null;
//   EWAYBILLNO: string | null;
//   subjects: string | null;
//   link: string | null;
//   party_invoice_no: string | null;
//   invoice_value: number | string | null;
//   internalDescription: string | null;
//   notesitems: string | null;
//   created_at: string | null;
//   "InvoiceNo.": string | null;
// }

// // Clean, ergonomic shape used throughout the component.
// interface Invoice {
//   id: number;
//   invoiceNo: string;
//   ewayBillNo: string | null;
//   partyInvoiceNo: string | null;
//   company: string;
//   sender: string | null;
//   receiver: string | null;
//   broker: string | null;
//   transporter: string | null;
//   driver: string | null;
//   vehicle: string | null;
//   paymentTerms: string | null;
//   paymentPayableBy: string | null;
//   source: string;
//   destination: string;
//   paymentStatus: string | null;
//   senderAmountStatus: string | null;
//   receiverAmountStatus: string | null;
//   transporterAmountStatus: string | null;
//   itemsDescription: string | null;
//   subjects: string | null;
//   link: string | null;
//   invoiceValue: number;
//   internalDescription: string | null;
//   notes: string | null;
//   createdAt: string | null;
// }

// interface RawInvoiceItem {
//   id: number;
//   invoiceId: number;
//   description: string;
//   hsm_code: string | null;
//   uom: string | null;
//   qty: number | string;
//   amount: number | string;
// }

// interface PaymentRecord {
//   amount: number | string;
//   paymentMode: string;
//   date: string;
// }

// interface SettlementDistribution {
//   id: number;
//   settlement_id: number;
//   invoice_id: number;
//   user_type: string;
//   user_name: string;
//   amount: number | string;
//   paid: number;
//   paymentRecords: PaymentRecord[];
// }

// interface Settlement {
//   id: number;
//   invoice_id: number;
//   invoice_no: string;
//   total_amount: number | string;
//   total_allocated: number | string;
//   total_paid: number | string;
//   status: string;
//   distributions: SettlementDistribution[];
// }

// /* ============================================================
//    Mappers
//    ============================================================ */

// const mapInvoice = (r: RawInvoiceRow): Invoice => ({
//   id: r.id,
//   invoiceNo: r["InvoiceNo."] || `INV-${r.id}`,
//   ewayBillNo: r.EWAYBILLNO || null,
//   partyInvoiceNo: r.party_invoice_no || null,
//   company: r.company || "—",
//   sender: r.sender || null,
//   receiver: r.receiver || null,
//   broker: r.broker || null,
//   transporter: r.transporter || null,
//   driver: r.driver || null,
//   vehicle: r.vehicles || null,
//   paymentTerms: r.payment || null,
//   paymentPayableBy: r.paymentPayableConsignor || null,
//   source: r.source || "—",
//   destination: r.destination || "—",
//   paymentStatus: r.paymentStatus || null,
//   senderAmountStatus: r.senderAmountStatatus || null,
//   receiverAmountStatus: r.receiverAmountStatatus || null,
//   transporterAmountStatus: r.transporterAmountStatatus || null,
//   itemsDescription: r.ItemsDescription || null,
//   subjects: r.subjects || null,
//   link: r.link || null,
//   invoiceValue: Number(r.invoice_value || 0),
//   internalDescription: r.internalDescription || null,
//   notes: r.notesitems || null,
//   createdAt: r.created_at || null,
// });

// /* ============================================================
//    Helpers
//    ============================================================ */

// const API = (): string => process.env.REACT_APP_API_URL || "";

// type PaymentCategory = "paid" | "partial" | "pending" | "unknown";

// const classifyStatus = (status?: string | null): PaymentCategory => {
//   const s = (status || "").toLowerCase().trim();
//   if (!s) return "unknown";
//   if (s.includes("partial")) return "partial";
//   if (s.includes("paid") || s.includes("clear") || s.includes("complete") || s.includes("settle")) return "paid";
//   if (s.includes("pend") || s.includes("due") || s.includes("unpaid") || s.includes("outstanding")) return "pending";
//   return "unknown";
// };

// const statusMeta: Record<PaymentCategory, { dot: string; chip: string; bar: string }> = {
//   paid: { dot: "bg-emerald-400", chip: "bg-emerald-50 text-emerald-600 border-emerald-200", bar: "bg-emerald-500" },
//   partial: { dot: "bg-blue-400", chip: "bg-blue-50 text-blue-600 border-blue-200", bar: "bg-blue-500" },
//   pending: { dot: "bg-amber-400", chip: "bg-amber-50 text-amber-600 border-amber-200", bar: "bg-amber-400" },
//   unknown: { dot: "bg-slate-400", chip: "bg-slate-50 text-slate-600 border-slate-200", bar: "bg-slate-300" },
// };

// const progressForCategory = (c: PaymentCategory): number =>
//   c === "paid" ? 100 : c === "partial" ? 55 : c === "pending" ? 15 : 0;

// const formatDate = (v?: string | null): string => {
//   if (!v) return "—";
//   const d = new Date(v);
//   return Number.isNaN(d.getTime())
//     ? "—"
//     : d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
// };

// const inr = (n: number): string =>
//   new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

// const initials = (v?: string | null): string => {
//   const s = String(v || "").replace(/\s+/g, " ").trim();
//   if (!s) return "NA";
//   const p = s.split(" ").filter(Boolean);
//   return `${p[0]?.[0] ?? "N"}${(p.length > 1 ? p[p.length - 1]?.[0] : p[0]?.[1]) ?? ""}`.toUpperCase();
// };

// /* ============================================================
//    Small UI atoms
//    ============================================================ */

// const Spinner = ({ size = 16 }: { size?: number }) => (
//   <svg className="animate-spin" width={size} height={size} viewBox="0 0 24 24" fill="none">
//     <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-20" />
//     <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
//   </svg>
// );

// const StatusChip = ({ status }: { status?: string | null }) => {
//   const cat = classifyStatus(status);
//   const meta = statusMeta[cat];
//   const label = status && status.trim() ? status : "Not set";
//   return (
//     <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border capitalize ${meta.chip}`}>
//       <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
//       {label}
//     </span>
//   );
// };

// /* ============================================================
//    Main Component
//    ============================================================ */

// interface TabDef {
//   label: string;
//   match: (c: PaymentCategory) => boolean;
// }

// const TABS: TabDef[] = [
//   { label: "All", match: () => true },
//   { label: "Paid", match: (c) => c === "paid" },
//   { label: "Pending", match: (c) => c === "pending" },
//   { label: "Partial", match: (c) => c === "partial" },
// ];

// const AdminDashboard = () => {
//   const [invoices, setInvoices] = useState<Invoice[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   const [activeTab, setActiveTab] = useState("All");
//   const [search, setSearch] = useState("");

//   const [selectedId, setSelectedId] = useState<number | null>(null);
//   const [detail, setDetail] = useState<Invoice | null>(null);
//   const [items, setItems] = useState<RawInvoiceItem[]>([]);
//   const [settlement, setSettlement] = useState<Settlement | null>(null);
//   const [detailLoading, setDetailLoading] = useState(false);

//   const [downloading, setDownloading] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [detailOpen, setDetailOpen] = useState(false);

//   /* ---------- Fetch invoice list (= consignments) ---------- */
//   useEffect(() => {
//     const apiUrl = API();
//     if (!apiUrl) {
//       setLoading(false);
//       setError("API URL is not configured.");
//       return;
//     }

//     let mounted = true;
//     (async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(`${apiUrl}/invoiceapi/invoice`);
//         if (!res.ok) throw new Error("Failed to fetch invoices");
//         const data = (await res.json()) as RawInvoiceRow[];
//         if (!mounted) return;
//         const mapped = data.map(mapInvoice).sort((a, b) => b.id - a.id);
//         setInvoices(mapped);
//         if (mapped.length > 0) setSelectedId(mapped[0].id);
//         setError(null);
//       } catch {
//         if (mounted) setError("Could not load invoices from the server.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     })();
//     return () => { mounted = false; };
//   }, []);

//   /* ---------- Fetch detail + items + settlement when selected ---------- */
//   useEffect(() => {
//     const apiUrl = API();
//     if (!selectedId || !apiUrl) return;

//     let mounted = true;
//     (async () => {
//       try {
//         setDetailLoading(true);
//         const [invRes, itemsRes, settleRes] = await Promise.all([
//           fetch(`${apiUrl}/invoiceapi/invoice/${selectedId}`),
//           fetch(`${apiUrl}/invoiceapi/invoice_items/invoice/${selectedId}`).catch(() => null),
//           fetch(`${apiUrl}/settlment/${selectedId}`).catch(() => null),
//         ]);

//         if (invRes.ok && mounted) {
//           const raw = (await invRes.json()) as RawInvoiceRow;
//           setDetail(mapInvoice(raw));
//         } else if (mounted) {
//           setDetail(null);
//         }

//         if (itemsRes && itemsRes.ok && mounted) {
//           const raw = (await itemsRes.json()) as RawInvoiceItem[];
//           setItems(Array.isArray(raw) ? raw : []);
//         } else if (mounted) {
//           setItems([]);
//         }

//         if (settleRes && settleRes.ok && mounted) {
//           const raw = await settleRes.json();
//           setSettlement(raw && raw.id ? (raw as Settlement) : null);
//         } else if (mounted) {
//           setSettlement(null);
//         }
//       } catch {
//         /* keep stale detail */
//       } finally {
//         if (mounted) setDetailLoading(false);
//       }
//     })();
//     return () => { mounted = false; };
//   }, [selectedId]);

//   /* ---------- Responsive cleanup ---------- */
//   useEffect(() => {
//     const onResize = () => {
//       if (window.innerWidth >= 1024) {
//         setSidebarOpen(false);
//         setDetailOpen(false);
//       }
//     };
//     window.addEventListener("resize", onResize);
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   /* ---------- Derived data ---------- */
//   const filtered = useMemo(() => {
//     const tab = TABS.find((t) => t.label === activeTab) ?? TABS[0];
//     const q = search.trim().toLowerCase();
//     return invoices.filter((inv) => {
//       const cat = classifyStatus(inv.paymentStatus);
//       if (!tab.match(cat)) return false;
//       if (!q) return true;
//       return (
//         inv.invoiceNo.toLowerCase().includes(q) ||
//         String(inv.id).includes(q) ||
//         (inv.company || "").toLowerCase().includes(q) ||
//         (inv.source || "").toLowerCase().includes(q) ||
//         (inv.destination || "").toLowerCase().includes(q) ||
//         (inv.transporter || "").toLowerCase().includes(q)
//       );
//     });
//   }, [invoices, activeTab, search]);

//   const stats = useMemo(() => {
//     const total = invoices.length;
//     const totalValue = invoices.reduce((s, r) => s + Number(r.invoiceValue || 0), 0);
//     const paid = invoices.filter((r) => classifyStatus(r.paymentStatus) === "paid").length;
//     const awaiting = invoices.filter((r) => {
//       const c = classifyStatus(r.paymentStatus);
//       return c === "pending" || c === "partial";
//     }).length;
//     return { total, totalValue, paid, awaiting };
//   }, [invoices]);

//   const tabCounts = useMemo(() => {
//     return TABS.map((t) => ({
//       label: t.label,
//       count: invoices.filter((r) => t.match(classifyStatus(r.paymentStatus))).length,
//     }));
//   }, [invoices]);

//   /* ---------- Detail computed values ---------- */
//   const itemTotals = useMemo(() => {
//     const qty = items.reduce((s, i) => s + Number(i.qty || 0), 0);
//     const amount = items.reduce((s, i) => s + Number(i.amount || 0), 0);
//     return { count: items.length, qty, amount };
//   }, [items]);

//   const settlementTotals = useMemo(() => {
//     const allocated = Number(settlement?.total_allocated || 0);
//     const paid = Number(settlement?.total_paid || 0);
//     return { allocated, paid, outstanding: allocated - paid };
//   }, [settlement]);

//   /* ---------- Actions ---------- */
//   const selectLoad = useCallback((id: number) => {
//     setSelectedId(id);
//     if (window.innerWidth < 1024) {
//       setSidebarOpen(false);
//       setDetailOpen(true);
//     }
//   }, []);

//   const downloadInvoice = useCallback(async () => {
//     const apiUrl = API();
//     if (!apiUrl || !selectedId) return;
//     try {
//       setDownloading(true);
//       const res = await fetch(`${apiUrl}/invoiceapi/pdf/${selectedId}`);
//       if (!res.ok) throw new Error("download failed");
//       const blob = await res.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `invoice-${detail?.invoiceNo || selectedId}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch {
//       /* silent */
//     } finally {
//       setDownloading(false);
//     }
//   }, [selectedId, detail]);

//   /* ============================================================
//      Render
//      ============================================================ */
//   return (
//     <div className="flex flex-col lg:flex-row h-full min-h-[700px] bg-slate-50 font-sans text-slate-800 relative">
//       {/* ---------------- Mobile top bar ---------------- */}
//       <div className="lg:hidden flex items-center justify-between px-4 h-14 bg-white border-b border-slate-100 sticky top-0 z-20">
//         <button
//           onClick={() => setSidebarOpen(true)}
//           className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center"
//           aria-label="Open menu"
//         >
//           <svg width="20" height="20" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//             <path d="M4 7h16M4 12h16M4 17h16" />
//           </svg>
//         </button>
//         <h1 className="text-base font-bold text-slate-900">Invoices</h1>
//         <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center text-white text-xs font-bold">
//           AD
//         </div>
//       </div>

//       {/* ================= SIDEBAR ================= */}
//       <aside
//         className={`fixed lg:static inset-y-0 left-0 z-40 w-[88%] max-w-sm lg:w-[360px]
//           bg-white border-r border-slate-100 flex flex-col shrink-0
//           transition-transform duration-300
//           ${sidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"} lg:translate-x-0`}
//       >
//         {/* Header */}
//         <div className="px-5 pt-5 pb-3">
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <h1 className="text-lg font-bold text-slate-900 tracking-tight">Consignment Invoices</h1>
//               <p className="text-xs text-slate-400">{stats.total} total invoices</p>
//             </div>
//             <div className="hidden lg:flex items-center gap-2">
//               <button className="w-9 h-9 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition">
//                 <svg width="16" height="16" fill="#475569" viewBox="0 0 24 24">
//                   <path d="M12 22c1.1 0 2-.9 2-2H10c0 1.1.9 2 2 2zm6-6V11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
//                 </svg>
//               </button>
//               <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 flex items-center justify-center text-white text-xs font-bold">
//                 AD
//               </div>
//             </div>
//             <button
//               onClick={() => setSidebarOpen(false)}
//               className="lg:hidden w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center"
//             >
//               <svg width="14" height="14" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M18 6L6 18M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           {/* Search */}
//           <div className="relative">
//             <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//               <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
//             </svg>
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search invoice no, route, transporter…"
//               className="w-full pl-9 pr-3 py-2.5 text-sm bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 placeholder-slate-400 transition"
//             />
//           </div>
//         </div>

//         {/* Tabs */}
//         <div className="flex gap-1.5 px-5 pb-3 overflow-x-auto no-scrollbar">
//           {tabCounts.map((tab) => (
//             <button
//               key={tab.label}
//               onClick={() => setActiveTab(tab.label)}
//               className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition ${
//                 activeTab === tab.label
//                   ? "bg-slate-900 text-white shadow-sm"
//                   : "text-slate-500 bg-slate-50 hover:bg-slate-100"
//               }`}
//             >
//               {tab.label}
//               <span className={`text-[10px] rounded-full px-1.5 py-px ${activeTab === tab.label ? "bg-white/20" : "bg-slate-200 text-slate-600"}`}>
//                 {tab.count}
//               </span>
//             </button>
//           ))}
//         </div>

//         {/* List */}
//         <div className="flex-1 overflow-y-auto px-3 pb-4 space-y-2">
//           {loading && (
//             <div className="flex flex-col items-center justify-center py-16 text-slate-400 gap-3">
//               <Spinner size={22} />
//               <span className="text-xs">Loading invoices…</span>
//             </div>
//           )}

//           {error && !loading && (
//             <div className="mx-2 mt-4 p-4 rounded-xl bg-rose-50 border border-rose-100 text-rose-600 text-xs">
//               {error}
//             </div>
//           )}

//           {!loading && !error && filtered.length === 0 && (
//             <div className="flex flex-col items-center justify-center py-16 text-slate-400 gap-2">
//               <svg width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
//                 <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//                 <path d="m3.27 6.96 8.73 5.05 8.73-5.05M12 22.08V12" />
//               </svg>
//               <span className="text-xs">No invoices found</span>
//             </div>
//           )}

//           {!loading && !error && filtered.map((inv) => {
//             const isActive = selectedId === inv.id;
//             const cat = classifyStatus(inv.paymentStatus);
//             const progress = progressForCategory(cat);
//             return (
//               <button
//                 key={inv.id}
//                 onClick={() => selectLoad(inv.id)}
//                 className={`w-full text-left p-3.5 rounded-2xl border transition-all duration-200 ${
//                   isActive
//                     ? "border-indigo-200 bg-indigo-50/60 shadow-sm ring-1 ring-indigo-100"
//                     : "border-slate-100 bg-white hover:border-slate-200 hover:shadow-sm"
//                 }`}
//               >
//                 <div className="flex items-start justify-between mb-2.5">
//                   <div className="min-w-0">
//                     <p className="text-sm font-semibold text-slate-900 truncate">{inv.invoiceNo}</p>
//                     <p className="text-[11px] text-slate-400">{inv.company} · {formatDate(inv.createdAt)}</p>
//                   </div>
//                   <StatusChip status={inv.paymentStatus} />
//                 </div>

//                 {/* Route */}
//                 <div className="flex items-center gap-2 text-[11px] text-slate-500 mb-2">
//                   <span className="font-medium truncate max-w-[35%]" title={inv.source}>{inv.source}</span>
//                   <div className="flex-1 flex items-center gap-1">
//                     <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 shrink-0" />
//                     <div className="flex-1 border-t border-dashed border-slate-300" />
//                     <svg width="12" height="12" fill="#94a3b8" viewBox="0 0 24 24">
//                       <path d="M17 8C8 10 5.9 16.17 3.82 21L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20c4 0 4-2 8-2s4 2 8 2v-2c-4 0-4-2-8-2c-1.13 0-1.9.16-2.53.33C14.28 12.07 16 9.66 17 8z" />
//                     </svg>
//                     <div className="w-1.5 h-1.5 rounded-full bg-rose-400 shrink-0" />
//                   </div>
//                   <span className="font-medium truncate max-w-[35%] text-right" title={inv.destination}>{inv.destination}</span>
//                 </div>

//                 <div className="flex justify-between text-[11px] text-slate-400 gap-2 mb-2.5">
//                   <span className="truncate max-w-[55%]" title={inv.transporter || ""}>🚚 {inv.transporter || "No transporter set"}</span>
//                   <span className="truncate max-w-[40%] text-right">{inv.ewayBillNo ? `E-way ${inv.ewayBillNo}` : "—"}</span>
//                 </div>

//                 {/* Footer: avatars + amount + progress */}
//                 <div className="flex items-center justify-between">
//                   <div className="flex -space-x-1.5">
//                     <div className="w-6 h-6 rounded-full bg-slate-900 text-white flex items-center justify-center text-[9px] font-bold ring-2 ring-white" title={`Sender: ${inv.sender || "—"}`}>
//                       {initials(inv.sender)}
//                     </div>
//                     <div className="w-6 h-6 rounded-full bg-white border border-slate-300 text-slate-700 flex items-center justify-center text-[9px] font-bold ring-2 ring-white" title={`Receiver: ${inv.receiver || "—"}`}>
//                       {initials(inv.receiver)}
//                     </div>
//                   </div>
//                   <span className="text-xs font-bold text-slate-700">{inr(inv.invoiceValue)}</span>
//                 </div>

//                 <div className="mt-2.5 w-full h-1.5 rounded-full bg-slate-100 overflow-hidden">
//                   <div
//                     className={`h-full rounded-full transition-all duration-500 ${statusMeta[cat].bar}`}
//                     style={{ width: `${progress}%` }}
//                   />
//                 </div>
//               </button>
//             );
//           })}
//         </div>
//       </aside>

//       {/* Sidebar overlay (mobile) */}
//       {sidebarOpen && (
//         <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />
//       )}

//       {/* ================= MAIN ================= */}
//       <main className="flex-1 flex flex-col overflow-hidden">
//         {/* Stat cards */}
//         <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4 p-4 md:p-5 md:pb-0">
//           {[
//             { label: "Total Invoices", value: String(stats.total), sub: "consignment invoices", icon: "🧾", grad: "from-indigo-500 to-violet-500" },
//             { label: "Invoice Value", value: inr(stats.totalValue), sub: "across all invoices", icon: "💰", grad: "from-violet-500 to-purple-500" },
//             { label: "Paid", value: String(stats.paid), sub: "fully settled", icon: "✅", grad: "from-emerald-500 to-teal-500" },
//             { label: "Awaiting Payment", value: String(stats.awaiting), sub: "pending or partial", icon: "⏳", grad: "from-amber-500 to-orange-500" },
//           ].map((s) => (
//             <div key={s.label} className="rounded-2xl bg-white border border-slate-100 p-4 shadow-sm hover:shadow-md transition-shadow">
//               <div className="flex items-start justify-between mb-3">
//                 <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${s.grad} flex items-center justify-center text-lg shadow-sm`}>
//                   {s.icon}
//                 </div>
//               </div>
//               <p className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight truncate">{s.value}</p>
//               <p className="text-xs font-medium text-slate-500 mt-0.5">{s.label}</p>
//               <p className="text-[11px] text-slate-400">{s.sub}</p>
//             </div>
//           ))}
//         </div>

//         {/* Detail content area */}
//         <div className="flex-1 overflow-y-auto p-4 md:p-5">
//           {!selectedId && !loading && (
//             <div className="h-full min-h-[300px] flex flex-col items-center justify-center text-slate-400 gap-3">
//               <svg width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
//                 <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//               </svg>
//               <p className="text-sm">Select an invoice to view details</p>
//             </div>
//           )}

//           {selectedId && (
//             <div className="hidden lg:grid grid-cols-1 xl:grid-cols-3 gap-5">
//               {/* Left: Header + Items + Settlement */}
//               <div className="xl:col-span-2 space-y-5">
//                 <DetailHeader
//                   detail={detail}
//                   loading={detailLoading}
//                   itemTotals={itemTotals}
//                   downloading={downloading}
//                   onDownload={downloadInvoice}
//                 />
//                 <ItemsCard items={items} loading={detailLoading} totals={itemTotals} />
//                 <SettlementCard settlement={settlement} loading={detailLoading} totals={settlementTotals} />
//               </div>

//               {/* Right: Parties + Notes */}
//               <div className="space-y-5">
//                 <PartiesCard detail={detail} />
//                 <NotesCard detail={detail} />
//               </div>
//             </div>
//           )}
//         </div>
//       </main>

//       {/* ================= MOBILE DETAIL DRAWER ================= */}
//       {detailOpen && (
//         <div className="fixed inset-0 z-50 lg:hidden flex">
//           <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setDetailOpen(false)} />
//           <div className="relative ml-auto w-full max-w-md h-full bg-slate-50 overflow-y-auto animate-[slideIn_.25s_ease]">
//             <div className="sticky top-0 z-10 flex items-center justify-between px-4 h-14 bg-white border-b border-slate-100">
//               <p className="text-sm font-bold text-slate-900">{detail?.invoiceNo || `Invoice #${selectedId}`}</p>
//               <button onClick={() => setDetailOpen(false)} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center">
//                 <svg width="14" height="14" fill="none" stroke="#334155" strokeWidth="2" viewBox="0 0 24 24">
//                   <path d="M18 6L6 18M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//             <div className="p-4 space-y-4">
//               <DetailHeader detail={detail} loading={detailLoading} itemTotals={itemTotals} downloading={downloading} onDownload={downloadInvoice} />
//               <PartiesCard detail={detail} />
//               <ItemsCard items={items} loading={detailLoading} totals={itemTotals} />
//               <SettlementCard settlement={settlement} loading={detailLoading} totals={settlementTotals} />
//               <NotesCard detail={detail} />
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes slideIn { from { transform: translateX(100%); } to { transform: translateX(0); } }
//         .no-scrollbar::-webkit-scrollbar { display: none; }
//         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
//       `}</style>
//     </div>
//   );
// };

// /* ============================================================
//    Sub-components
//    ============================================================ */

// const DetailHeader = ({
//   detail, loading, itemTotals, downloading, onDownload,
// }: {
//   detail: Invoice | null;
//   loading: boolean;
//   itemTotals: { count: number; qty: number; amount: number };
//   downloading: boolean;
//   onDownload: () => void;
// }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm overflow-hidden">
//     <div className="p-5 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
//       <div className="flex items-start justify-between gap-3">
//         <div className="min-w-0">
//           <p className="text-[11px] uppercase tracking-widest text-slate-400 mb-1">Invoice No</p>
//           <h2 className="text-xl font-bold truncate">{detail?.invoiceNo || "—"}</h2>
//           <p className="text-xs text-slate-400 mt-1">
//             {detail?.company || "—"} · Created {formatDate(detail?.createdAt)}
//           </p>
//         </div>
//         <StatusChip status={detail?.paymentStatus} />
//       </div>

//       <div className="grid grid-cols-3 gap-3 mt-5">
//         {[
//           { k: "Items", v: loading ? "…" : String(itemTotals.count) },
//           { k: "Items Amount", v: loading ? "…" : inr(itemTotals.amount) },
//           { k: "Invoice Value", v: loading ? "…" : inr(detail?.invoiceValue || 0) },
//         ].map((m) => (
//           <div key={m.k} className="rounded-xl bg-white/10 backdrop-blur px-3 py-2.5">
//             <p className="text-[10px] uppercase tracking-wide text-slate-400">{m.k}</p>
//             <p className="text-base font-bold truncate">{m.v}</p>
//           </div>
//         ))}
//       </div>
//     </div>

//     <div className="p-4 flex flex-wrap items-center gap-3">
//       <div className="flex items-center gap-2 text-xs text-slate-500">
//         <span className="font-medium text-slate-700">E-way bill:</span>
//         <span className="px-2 py-0.5 rounded-md bg-slate-100">{detail?.ewayBillNo || "—"}</span>
//       </div>
//       <div className="flex items-center gap-2 text-xs text-slate-500">
//         <span className="font-medium text-slate-700">Party invoice no:</span>
//         <span>{detail?.partyInvoiceNo || "—"}</span>
//       </div>
//       <div className="flex items-center gap-2 text-xs text-slate-500">
//         <span className="font-medium text-slate-700">Payment terms:</span>
//         <span className="capitalize">{detail?.paymentTerms || "—"}</span>
//       </div>
//       <button
//         onClick={onDownload}
//         disabled={!detail || downloading}
//         className="ml-auto inline-flex items-center gap-2 text-xs font-semibold px-4 py-2.5 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 transition"
//       >
//         {downloading ? <Spinner size={14} /> : (
//           <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
//           </svg>
//         )}
//         {downloading ? "Downloading…" : "Download Invoice PDF"}
//       </button>
//     </div>
//   </div>
// );

// const PartyRow = ({ label, name, status }: { label: string; name?: string | null; status?: string | null }) => (
//   <div className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 border border-slate-100">
//     <div className="w-9 h-9 rounded-lg bg-indigo-100 text-indigo-600 flex items-center justify-center text-xs font-bold shrink-0">
//       {initials(name)}
//     </div>
//     <div className="min-w-0 flex-1">
//       <p className="text-[11px] uppercase tracking-wide text-slate-400">{label}</p>
//       <p className="text-sm font-medium text-slate-800 truncate">{name || "Not set"}</p>
//     </div>
//     {status !== undefined && <StatusChip status={status} />}
//   </div>
// );

// const PartiesCard = ({ detail }: { detail: Invoice | null }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2">
//       <svg width="16" height="16" fill="none" stroke="#6366f1" strokeWidth="2" viewBox="0 0 24 24">
//         <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
//       </svg>
//       Route &amp; Parties
//     </h3>

//     <div className="relative pl-6 mb-5">
//       <div className="absolute left-[7px] top-3 bottom-3 w-0.5 bg-gradient-to-b from-indigo-300 to-rose-300" />
//       <div className="relative mb-5">
//         <div className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-indigo-500 ring-4 ring-indigo-100" />
//         <p className="text-[11px] uppercase tracking-wide text-slate-400">Source</p>
//         <p className="text-sm font-medium text-slate-800">{detail?.source || "—"}</p>
//       </div>
//       <div className="relative">
//         <div className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-rose-500 ring-4 ring-rose-100" />
//         <p className="text-[11px] uppercase tracking-wide text-slate-400">Destination</p>
//         <p className="text-sm font-medium text-slate-800">{detail?.destination || "—"}</p>
//       </div>
//     </div>

//     <div className="space-y-2">
//       <PartyRow label="Sender" name={detail?.sender} status={detail?.senderAmountStatus} />
//       <PartyRow label="Receiver" name={detail?.receiver} status={detail?.receiverAmountStatus} />
//       <PartyRow label="Transporter" name={detail?.transporter} status={detail?.transporterAmountStatus} />
//       <PartyRow label="Broker" name={detail?.broker} />
//       <div className="grid grid-cols-2 gap-2">
//         <PartyRow label="Driver" name={detail?.driver} />
//         <PartyRow label="Vehicle" name={detail?.vehicle} />
//       </div>
//     </div>
//   </div>
// );

// const ItemsCard = ({ items, loading, totals }: { items: RawInvoiceItem[]; loading: boolean; totals: { count: number; qty: number; amount: number } }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <div className="flex items-center justify-between mb-4">
//       <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
//         <svg width="16" height="16" fill="none" stroke="#0ea5e9" strokeWidth="2" viewBox="0 0 24 24">
//           <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//         </svg>
//         Items
//         <span className="text-[11px] font-semibold text-slate-400">({totals.count})</span>
//       </h3>
//       <span className="text-xs font-semibold text-slate-500">{totals.qty.toLocaleString("en-IN")} units</span>
//     </div>

//     {loading ? (
//       <div className="py-6 flex justify-center text-slate-300"><Spinner size={18} /></div>
//     ) : items.length === 0 ? (
//       <p className="text-xs text-slate-400 py-4 text-center">No line items recorded for this invoice</p>
//     ) : (
//       <div className="space-y-2">
//         {items.map((it) => (
//           <div key={it.id} className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 border border-slate-100">
//             <div className="w-9 h-9 rounded-lg bg-sky-100 text-sky-600 flex items-center justify-center text-xs font-bold shrink-0">
//               {initials(it.description)}
//             </div>
//             <div className="min-w-0 flex-1">
//               <p className="text-sm font-semibold text-slate-800 truncate">{it.description}</p>
//               <p className="text-[11px] text-slate-400">
//                 HSN {it.hsm_code || "—"} · {Number(it.qty)} {it.uom || "units"}
//               </p>
//             </div>
//             <div className="text-right shrink-0">
//               <p className="text-sm font-bold text-slate-700">{inr(Number(it.amount))}</p>
//             </div>
//           </div>
//         ))}
//         <div className="flex items-center justify-between pt-2 px-1">
//           <span className="text-xs font-semibold text-slate-500">Items total</span>
//           <span className="text-sm font-bold text-slate-900">{inr(totals.amount)}</span>
//         </div>
//       </div>
//     )}
//   </div>
// );

// const SettlementCard = ({
//   settlement, loading, totals,
// }: { settlement: Settlement | null; loading: boolean; totals: { allocated: number; paid: number; outstanding: number } }) => (
//   <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//     <div className="flex items-center justify-between mb-4">
//       <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
//         <svg width="16" height="16" fill="none" stroke="#8b5cf6" strokeWidth="2" viewBox="0 0 24 24">
//           <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
//         </svg>
//         Settlement
//         {settlement && <span className="text-[11px] font-semibold text-slate-400">({settlement.distributions?.length || 0})</span>}
//       </h3>
//       {settlement && <StatusChip status={settlement.status} />}
//     </div>

//     {loading ? (
//       <div className="py-6 flex justify-center text-slate-300"><Spinner size={18} /></div>
//     ) : !settlement ? (
//       <p className="text-xs text-slate-400 py-4 text-center">No settlement has been generated for this invoice yet</p>
//     ) : (
//       <>
//         <div className="space-y-2 mb-4">
//           {(settlement.distributions || []).map((d) => {
//             const paidAmt = (d.paymentRecords || []).reduce((s, p) => s + Number(p.amount || 0), 0);
//             return (
//               <div key={d.id} className="p-3 rounded-xl bg-slate-50 border border-slate-100">
//                 <div className="flex items-center justify-between mb-1.5">
//                   <div className="flex items-center gap-2.5 min-w-0">
//                     <span className={`w-2 h-2 rounded-full shrink-0 ${d.paid ? "bg-emerald-400" : "bg-amber-400"}`} />
//                     <div className="min-w-0">
//                       <p className="text-sm font-medium text-slate-700 truncate">{d.user_name}</p>
//                       <p className="text-[11px] text-slate-400 capitalize">{d.user_type}</p>
//                     </div>
//                   </div>
//                   <div className="text-right shrink-0">
//                     <p className="text-sm font-semibold text-slate-700">{inr(Number(d.amount))}</p>
//                     <p className={`text-[10px] font-bold ${d.paid ? "text-emerald-500" : "text-amber-500"}`}>
//                       {d.paid ? "PAID" : "PENDING"}
//                     </p>
//                   </div>
//                 </div>
//                 {(d.paymentRecords || []).length > 0 ? (
//                   <div className="mt-2 pt-2 border-t border-slate-200 space-y-1">
//                     {d.paymentRecords.map((p, idx) => (
//                       <div key={idx} className="flex items-center justify-between text-[11px] text-slate-500">
//                         <span className="capitalize">{p.paymentMode} · {formatDate(p.date)}</span>
//                         <span className="font-semibold text-slate-600">{inr(Number(p.amount))}</span>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <p className="text-[11px] text-slate-400 mt-1">No payments recorded ({inr(paidAmt)} received so far)</p>
//                 )}
//               </div>
//             );
//           })}
//         </div>

//         <div className="grid grid-cols-3 gap-3 pt-3 border-t border-slate-100">
//           <div className="rounded-xl bg-slate-50 p-3">
//             <p className="text-[11px] text-slate-500 font-medium">Allocated</p>
//             <p className="text-base font-bold text-slate-800">{inr(totals.allocated)}</p>
//           </div>
//           <div className="rounded-xl bg-emerald-50 p-3">
//             <p className="text-[11px] text-emerald-600 font-medium">Paid</p>
//             <p className="text-base font-bold text-emerald-700">{inr(totals.paid)}</p>
//           </div>
//           <div className="rounded-xl bg-amber-50 p-3">
//             <p className="text-[11px] text-amber-600 font-medium">Outstanding</p>
//             <p className="text-base font-bold text-amber-700">{inr(totals.outstanding)}</p>
//           </div>
//         </div>
//       </>
//     )}
//   </div>
// );

// const NotesCard = ({ detail }: { detail: Invoice | null }) => {
//   const rows: { label: string; value: string | null }[] = [
//     { label: "Subjects", value: detail?.subjects || null },
//     { label: "Items description", value: detail?.itemsDescription || null },
//     { label: "Internal note", value: detail?.internalDescription || null },
//     { label: "Notes", value: detail?.notes || null },
//     { label: "Payment payable by", value: detail?.paymentPayableBy || null },
//   ].filter((r) => r.value);

//   const hasLink = detail?.link && /^https?:\/\//i.test(detail.link);

//   return (
//     <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-5">
//       <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2">
//         <svg width="16" height="16" fill="none" stroke="#10b981" strokeWidth="2" viewBox="0 0 24 24">
//           <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" />
//         </svg>
//         Notes &amp; Documents
//       </h3>

//       {rows.length === 0 && !hasLink && (
//         <p className="text-xs text-slate-400 py-4 text-center">No additional notes for this invoice</p>
//       )}

//       {rows.length > 0 && (
//         <div className="space-y-3 mb-3">
//           {rows.map((r) => (
//             <div key={r.label}>
//               <p className="text-[11px] uppercase tracking-wide text-slate-400">{r.label}</p>
//               <p className="text-sm text-slate-700 mt-0.5">{r.value}</p>
//             </div>
//           ))}
//         </div>
//       )}

//       {detail?.link && (
//         <div className="pt-3 border-t border-slate-100">
//           {hasLink ? (
//             <a
//               href={detail.link}
//               target="_blank"
//               rel="noreferrer"
//               className="inline-flex items-center gap-2 text-xs font-semibold text-indigo-600 hover:text-indigo-700"
//             >
//               <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path d="M10 14L21 3M21 3h-6M21 3v6M21 14v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
//               </svg>
//               View attached document
//             </a>
//           ) : (
//             <p className="text-xs text-slate-500">{detail.link}</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminDashboard;

// import { useEffect, useMemo, useState, useCallback, useRef } from "react";

// // ─── helpers ────────────────────────────────────────────────────────────────

// const API = () => process.env.REACT_APP_API_URL || "";

// const inr = (n: number | string): string =>
//   new Intl.NumberFormat("en-IN", {
//     style: "currency",
//     currency: "INR",
//     maximumFractionDigits: 0,
//   }).format(Number(n) || 0);

// const fmtDate = (v: string | number | Date | null | undefined): string => {
//   if (!v) return "—";
//   const d = new Date(v);
//   return isNaN(d.getTime())
//     ? String(v)
//     : d.toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
// };

// const initials = (v: string) => {
//   const s = String(v || "").trim();
//   if (!s || s === "—") return "??";
//   const p = s.split(" ").filter(Boolean);
//   return (
//     (p[0]?.[0] || "") +
//     (p.length > 1 ? p[p.length - 1]?.[0] : p[0]?.[1] || "")
//   ).toUpperCase();
// };

// // --- Status utilities ---
// const classifyStatus = (s: string): "paid" | "partial" | "pending" | "unknown" => {
//   const v = (s || "").toLowerCase();
//   if (v.includes("partial")) return "partial";
//   if (v.includes("paid") || v.includes("clear") || v.includes("settle")) return "paid";
//   if (v.includes("pend") || v.includes("due") || v.includes("unpaid")) return "pending";
//   return "unknown";
// };

// const STATUS_STYLES: Record<string, string> = {
//   paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
//   partial: "bg-blue-50 text-blue-700 border-blue-200",
//   pending: "bg-amber-50 text-amber-700 border-amber-200",
//   unknown: "bg-slate-100 text-slate-500 border-slate-200",
// };

// const STATUS_DOT: Record<string, string> = {
//   paid: "bg-emerald-400",
//   partial: "bg-blue-400",
//   pending: "bg-amber-400",
//   unknown: "bg-slate-400",
// };

// const PROGRESS_COLOR: Record<string, string> = {
//   paid: "bg-emerald-400",
//   partial: "bg-blue-400",
//   pending: "bg-amber-400",
//   unknown: "bg-slate-200",
// };

// const progressPct = (c: string): number => {
//   switch (c) {
//     case "paid": return 100;
//     case "partial": return 55;
//     case "pending": return 15;
//     default: return 0;
//   }
// };

// async function fetchJSON(url: string): Promise<any | null> {
//   try {
//     const r = await fetch(url);
//     if (!r.ok) return null;
//     return await r.json();
//   } catch {
//     return null;
//   }
// }

// // --- Invoice mapping ---
// function mapInvoice(r: any) {
//   return {
//     id: r.id,
//     invoiceNo: r["InvoiceNo."] || `INV-${r.id}`,
//     ewayBillNo: r.EWAYBILLNO || null,
//     partyInvoiceNo: r.party_invoice_no || null,
//     company: r.company || "—",
//     companyId: r.company_id || null,
//     sender: r.sender || null,
//     senderId: r.sender_id || null,
//     receiver: r.receiver || null,
//     receiverId: r.receiver_id || null,
//     transporter: r.transporter || null,
//     transporterId: r.transporter_id || null,
//     driver: r.driver || null,
//     driverId: r.driver_id || null,
//     vehicle: r.vehicles || null,
//     vehicleId: r.vehicle_id || null,
//     broker: r.broker || null,
//     paymentTerms: r.payment || null,
//     paymentPayableBy: r.paymentPayableConsignor || null,
//     source: r.source || "—",
//     destination: r.destination || "—",
//     paymentStatus: r.paymentStatus || null,
//     senderAmountStatus: r.senderAmountStatatus || null,
//     receiverAmountStatus: r.receiverAmountStatatus || null,
//     transporterAmountStatus: r.transporterAmountStatatus || null,
//     itemsDescription: r.ItemsDescription || null,
//     subjects: r.subjects || null,
//     link: r.link || null,
//     invoiceValue: Number(r.invoice_value || 0),
//     internalDescription: r.internalDescription || null,
//     notes: r.notesitems || null,
//     createdAt: r.created_at || null,
//   };
// }

// // --- Spinner Atom ---
// function Spinner({ size = 16 }: { size?: number }) {
//   return (
//     <svg
//       className="animate-spin text-slate-400"
//       width={size}
//       height={size}
//       viewBox="0 0 24 24"
//       fill="none"
//     >
//       <circle
//         cx="12"
//         cy="12"
//         r="10"
//         stroke="currentColor"
//         strokeWidth="3"
//         className="opacity-20"
//       />
//       <path
//         d="M22 12a10 10 0 0 1-10 10"
//         stroke="currentColor"
//         strokeWidth="3"
//         strokeLinecap="round"
//       />
//     </svg>
//   );
// }

// function StatusBadge({ status }: { status: string }) {
//   const cat = classifyStatus(status || "");
//   return (
//     <span
//       className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border capitalize ${STATUS_STYLES[cat]}`}
//     >
//       <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOT[cat]}`} />
//       {status && status.trim() ? status : "Not set"}
//     </span>
//   );
// }

// // --- PDF Viewer ---
// type PdfViewerProps = {
//   invoice: any;
//   items: Array<{ amount?: number | string; qty?: number | string; quantity?: number | string }>;
//   onClose: () => void;
// };

// function PdfViewer({ invoice, items, onClose }: PdfViewerProps) {
//   const itemAmtTotal = items.reduce((s: number, i) => s + Number(i.amount || 0), 0);
//   const itemQtyTotal = items.reduce(
//     (s: number, i) => s + Number(i.qty || i.quantity || 0),
//     0
//   );

//   return (
//     <div className="fixed inset-0 z-50 flex flex-col bg-slate-900/60 backdrop-blur-sm">
//       {/* header */}
//       <div className="bg-white border-b border-slate-200 px-5 h-14 flex items-center justify-between shrink-0">
//         <p className="text-sm font-semibold text-slate-900">
//           Invoice — {invoice.invoiceNo}
//         </p>
//         <div className="flex gap-2">
//           <button
//             onClick={() => window.print()}
//             className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
//           >
//             Print / Save PDF
//           </button>
//           <button
//             onClick={onClose}
//             className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
//           >
//             Close
//           </button>
//         </div>
//       </div>

//       {/* scrollable page */}
//       <div className="flex-1 overflow-auto bg-slate-100 py-8 px-4 flex justify-center">
//         <div
//           className="bg-white w-[800px] p-12 shadow-xl rounded-lg text-[13px] text-slate-800"
//           style={{ minHeight: 1050 }}
//         >
//           {/* title */}
//           <div className="flex justify-between items-start mb-8">
//             <div>
//               <h1 className="text-3xl font-bold text-slate-900 mb-1">
//                 INVOICE
//               </h1>
//               <p className="text-slate-500">{invoice.invoiceNo}</p>
//             </div>
//             <div className="text-right">
//               <p className="font-semibold text-slate-800">{invoice.company}</p>
//               <p className="text-slate-500 text-xs mt-0.5">
//                 Issued {fmtDate(invoice.createdAt)}
//               </p>
//               <StatusBadge status={invoice.paymentStatus} />
//             </div>
//           </div>

//           <hr className="border-slate-200 mb-6" />

//           {/* consignment */}
//           <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">
//             Consignment details
//           </p>
//           <div className="grid grid-cols-3 gap-4 mb-6">
//             {[
//               ["E-way bill no", invoice.ewayBillNo],
//               ["Party invoice no", invoice.partyInvoiceNo],
//               ["Payment terms", invoice.paymentTerms],
//               ["Source", invoice.source],
//               ["Destination", invoice.destination],
//               ["Payable by", invoice.paymentPayableBy],
//             ].map(([label, val]) => (
//               <div key={label}>
//                 <p className="text-[10px] text-slate-400 mb-0.5">{label}</p>
//                 <p className="font-medium">{val || "—"}</p>
//               </div>
//             ))}
//           </div>

//           {/* parties */}
//           <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">
//             Parties
//           </p>
//           <div className="grid grid-cols-3 gap-4 mb-6">
//             {[
//               ["Sender / Consignor", invoice.sender],
//               ["Receiver / Consignee", invoice.receiver],
//               ["Transporter", invoice.transporter],
//               ["Driver", invoice.driver],
//               ["Vehicle", invoice.vehicle],
//               ["Broker", invoice.broker],
//             ].map(([label, val]) => (
//               <div key={label}>
//                 <p className="text-[10px] text-slate-400 mb-0.5">{label}</p>
//                 <p className="font-medium">{val || "—"}</p>
//               </div>
//             ))}
//           </div>

//           {/* items */}
//           <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">
//             Items
//           </p>
//           <table className="w-full border-collapse mb-6">
//             <thead>
//               <tr className="bg-slate-50">
//                 {["#", "Description", "HSN", "UOM", "Qty", "Amount (INR)"].map(
//                   (h, i) => (
//                     <th
//                       key={h}
//                       className={`text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wide px-3 py-2 border border-slate-200 ${i >= 4 ? "text-right" : ""}`}
//                     >
//                       {h}
//                     </th>
//                   )
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {items.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan={6}
//                     className="px-3 py-4 text-center text-slate-400 border border-slate-200"
//                   >
//                     No items recorded
//                   </td>
//                 </tr>
//               ) : (
//                 items.map((it, i) => (
//                   <tr key={i}>
//                     <td className="px-3 py-2 border border-slate-200 text-slate-400">
//                       {i + 1}
//                     </td>
//                     <td className="px-3 py-2 border border-slate-200 font-medium">
//                       {/* @ts-expect-error */}
//                       {it.description || it.item_name || "—"}
//                     </td>
//                     <td className="px-3 py-2 border border-slate-200 text-slate-500">
//                       {/* @ts-expect-error */}
//                       {it.hsm_code || it.hsn_code || "—"}
//                     </td>
//                     <td className="px-3 py-2 border border-slate-200 text-slate-500">
//                       {/* @ts-expect-error */}
//                       {it.uom || it.unit || "—"}
//                     </td>
//                     <td className="px-3 py-2 border border-slate-200 text-right">
//                       {Number(
                  
//                         it.qty || it.quantity || 0
//                       ).toLocaleString("en-IN")}
//                     </td>
//                     <td className="px-3 py-2 border border-slate-200 text-right font-medium">
//                       {inr(
                      
//                         it.amount || 0
//                       )}
//                     </td>
//                   </tr>
//                 ))
     
//               )}
//               {/* totals row */}
//               <tr className="bg-slate-50 font-semibold">
//                 <td
//                   colSpan={4}
//                   className="px-3 py-2 border border-slate-200 text-right text-slate-500 text-[10px] uppercase tracking-wide"
//                 >
//                   Total
//                 </td>
//                 <td className="px-3 py-2 border border-slate-200 text-right">
//                   {itemQtyTotal.toLocaleString("en-IN")}
//                 </td>
//                 <td className="px-3 py-2 border border-slate-200 text-right">
//                   {inr(itemAmtTotal)}
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           {/* summary */}
//           <div className="flex justify-end mb-8">
//             <div className="w-64 border border-slate-200 rounded-lg overflow-hidden">
//               {[
//                 ["Items total", inr(itemAmtTotal)],
//                 ["Invoice value", inr(invoice.invoiceValue)],
//               ].map(([label, val]) => (
//                 <div
//                   key={label}
//                   className="flex justify-between items-center px-4 py-2.5 border-b border-slate-100 last:border-0"
//                 >
//                   <span className="text-slate-500 text-xs">{label}</span>
//                   <span className="font-semibold text-slate-800">{val}</span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* notes */}
//           {(invoice.subjects ||
//             invoice.notes ||
//             invoice.internalDescription) && (
//             <div className="mb-8">
//               <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">
//                 Notes
//               </p>
//               <div className="bg-slate-50 rounded-lg p-4 space-y-2 text-sm text-slate-700">
//                 {invoice.subjects && <p>{invoice.subjects}</p>}
//                 {invoice.internalDescription && (
//                   <p>{invoice.internalDescription}</p>
//                 )}
//                 {invoice.notes && <p>{invoice.notes}</p>}
//               </div>
//             </div>
//           )}

//           {/* signature */}
//           <div className="flex justify-end mt-12">
//             <div className="text-center w-48">
//               <div className="h-12 border-b border-slate-400 mb-2" />
//               <p className="text-xs text-slate-500">Authorised signatory</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // --- Edit Modal ---
// function EditModal({
//   invoice,
//   onClose,
//   onSave,
// }: {
//   invoice: any;
//   onClose: () => void;
//   onSave: (form: any) => void;
// }) {
//   const [form, setForm] = useState({ ...invoice });
//   const [saving, setSaving] = useState(false);

//   const field = (label: string, key: string, type: string = "text") => (
//     <div>
//       <label className="block text-xs text-slate-500 mb-1">{label}</label>
//       {type === "textarea" ? (
//         <textarea
//           className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
//           rows={2}
//           value={form[key] || ""}
//           onChange={(e) => setForm((f:any) => ({ ...f, [key]: e.target.value }))}
//         />
//       ) : type === "select-status" ? (
//         <select
//           className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
//           value={form[key] || ""}
//           onChange={(e) => setForm((f: any) => ({ ...f, [key]: e.target.value }))}
     
//         >
//           {["Paid", "Partial", "Pending", "Unpaid", "Settled", "Cleared"].map(
//             (s) => <option key={s}>{s}</option>
//           )}
//         </select>
//       ) : (
//         <input
//           type={type}
//           className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
//           value={form[key] || ""}
//           onChange={(e) => setForm((f:any) => ({ ...f, [key]: e.target.value }))}
//         />
//       )}
//     </div>
//   );

//   async function handleSave() {
//     setSaving(true);
//     try {
//       const r = await fetch(`${API()}/invoiceapi/invoice/${invoice.id}`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       if (r.ok) onSave(form);
//       else alert("Save failed — check API.");
//     } catch {
//       onSave(form); // Optimistic update
//     } finally {
//       setSaving(false);
//     }
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4">
//       <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 w-full max-w-xl flex flex-col max-h-[90vh]">
//         <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
//           <h2 className="text-sm font-semibold text-slate-900">
//             Edit invoice — {invoice.invoiceNo}
//           </h2>
//           <button
//             onClick={onClose}
//             className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400 transition"
//           >
//             ✕
//           </button>
//         </div>

//         <div className="overflow-y-auto flex-1 p-5 space-y-4">
//           <div className="grid grid-cols-2 gap-4">
//             {field("Invoice No", "invoiceNo")}
//             {field("E-way bill no", "ewayBillNo")}
//             {field("Source", "source")}
//             {field("Destination", "destination")}
//             {field("Sender / Consignor", "sender")}
//             {field("Receiver / Consignee", "receiver")}
//             {field("Transporter", "transporter")}
//             {field("Driver", "driver")}
//             {field("Vehicle", "vehicle")}
//             {field("Broker", "broker")}
//             {field("Invoice value (INR)", "invoiceValue", "number")}
//             {field("Payment status", "paymentStatus", "select-status")}
//             {field("Payment terms", "paymentTerms")}
//             {field("Party invoice no", "partyInvoiceNo")}
//           </div>
//           {field("Subjects", "subjects")}
//           {field("Internal notes", "internalDescription", "textarea")}
//           {field("Notes", "notes", "textarea")}
//         </div>

//         <div className="flex justify-end gap-2 px-5 py-4 border-t border-slate-100">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 rounded-lg text-sm border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
//           >
//             Cancel
//           </button>
//           <button
//             disabled={saving}
//             onClick={handleSave}
//             className="px-4 py-2 rounded-lg text-sm bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50 transition flex items-center gap-1.5"
//           >
//             {saving ? <Spinner size={14} /> : "✓"} Save changes
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // --- Name Resolver ---
// function useNameResolver() {
//   const cache = useRef<Record<string, string>>({});

//   const resolve = useCallback(async (type: string, id: any, fallback: any) => {
//     if (fallback && String(fallback).trim() && fallback !== "—") return fallback;
//     if (!id) return "—";
//     const key = `${type}_${id}`;
//     if (cache.current[key]) return cache.current[key];
//     let name = "—";
//     if (type === "user") {
//       const d = await fetchJSON(`${API()}/auth/user/${id}`);
//       name = d?.name || `User #${id}`;
//     } else if (type === "driver") {
//       const d = await fetchJSON(`${API()}/auth/drivers/${id}`);
//       name = d?.name || `Driver #${id}`;
//     } else if (type === "vehicle") {
//       const d = await fetchJSON(`${API()}/auth/vehicles/${id}`);
//       name = d?.vehicle_number || d?.registration_number || `Vehicle #${id}`;
//     }
//     cache.current[key] = name;
//     return name;
//   }, []);

//   return resolve;
// }

// // --- Detail Panel ---
// function DetailPanel({
//   invoice,
//   onEdit,
//   onViewPdf,
// }: {
//   invoice: any;
//   onEdit: () => void;
//   onViewPdf: (items: any[]) => void;
// }) {
//   const resolve = useNameResolver();
//   const [names, setNames] = useState<null | {
//     senderName?: string;
//     receiverName?: string;
//     driverName?: string;
//     vehicleName?: string;
//   }>(null);
//   const [items, setItems] = useState<any[]>([]);
//   const [settlement, setSettlement] = useState<any>(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!invoice) return;
//     let mounted = true;
//     setLoading(true);
//     setItems([]);
//     setSettlement(null);
//     setNames(null);

//     (async () => {
//       const [rawItems, settle] = await Promise.all([
//         fetchJSON(`${API()}/invoiceapi/invoice_items/invoice/${invoice.id}`).catch(() => null),
//         fetchJSON(`${API()}/settlment/${invoice.id}`).catch(() => null),
//       ]);

//       const [senderName, receiverName, driverName, vehicleName] =
//         await Promise.all([
//           resolve("user", invoice.senderId, invoice.sender),
//           resolve("user", invoice.receiverId, invoice.receiver),
//           resolve("driver", invoice.driverId, invoice.driver),
//           resolve("vehicle", invoice.vehicleId, invoice.vehicle),
//         ]);

//       if (!mounted) return;
//       setItems(Array.isArray(rawItems) ? rawItems : []);
//       setSettlement(settle?.id ? settle : null);
//       setNames({ senderName, receiverName, driverName, vehicleName });
//       setLoading(false);
//     })();

//     return () => { mounted = false; };
//   }, [invoice?.id]); // exhaustive deps

//   if (!invoice) {
//     return (
//       <div className="flex-1 flex flex-col items-center justify-center text-slate-300 gap-3">
//         <svg
//           width="52"
//           height="52"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1.5"
//           viewBox="0 0 24 24"
//         >
//           <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//           <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
//         </svg>
//         <p className="text-sm">Select an invoice to view details</p>
//       </div>
//     );
//   }

//   // --- calculate totals ---
//   const itemAmtTotal = items.reduce((s, i) => s + Number(i.amount || 0), 0);
//   const itemQtyTotal = items.reduce((s, i) => s + Number(i.qty || i.quantity || 0), 0);
//   const allocTotal = Number(settlement?.total_allocated || 0);
//   const paidTotal = Number(settlement?.total_paid || 0);

//   // Defensive fallback for names
//   const d = invoice;
//   const sName = names?.senderName || d.sender || "—";
//   const rName = names?.receiverName || d.receiver || "—";
//   const drName = names?.driverName || d.driver || "—";
//   const vName = names?.vehicleName || d.vehicle || "—";

//   return (
//     <div className="flex-1 flex flex-col overflow-hidden">
//       {/* action bar */}
//       <div className="shrink-0 flex items-center gap-2 px-5 py-3 border-b border-slate-100 bg-white">
//         <button
//           onClick={onEdit}
//           className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
//         >
//           ✎ Edit invoice
//         </button>
//         <button
//           onClick={() => onViewPdf(items)}
     
//           className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
//         >
//           ↓ View / Print PDF
//         </button>
//         <span className="flex-1" />
//         <span className="text-xs text-slate-400 font-medium">{d.invoiceNo}</span>
//       </div>

//       {/* scrollable content */}
//       <div className="flex-1 overflow-y-auto px-5 py-5 space-y-4">
//         {/* hero card */}
//         <div className="rounded-2xl overflow-hidden border border-slate-100 shadow-sm">
//           <div className="bg-gradient-to-br from-slate-900 to-slate-800 p-5 text-white">
//             <div className="flex items-start justify-between gap-3 mb-4">
//               <div>
//                 <p className="text-[10px] uppercase tracking-widest text-slate-400 mb-1">
//                   Invoice
//                 </p>
//                 <h2 className="text-2xl font-bold">{d.invoiceNo}</h2>
//                 <p className="text-xs text-slate-400 mt-1">
//                   {d.company} · {fmtDate(d.createdAt)}
//                 </p>
//               </div>
//               <StatusBadge status={d.paymentStatus} />
//             </div>
//             <div className="grid grid-cols-3 gap-2">
//               {[
//                 ["Items", loading ? "…" : items.length],
//                 ["Items total", loading ? "…" : inr(itemAmtTotal)],
//                 ["Invoice value", inr(d.invoiceValue)],
//               ].map(([label, val]) => (
//                 <div
//                   key={label}
//                   className="rounded-xl bg-white/10 backdrop-blur px-3 py-2.5"
//                 >
//                   <p className="text-[10px] text-slate-400 mb-1">{label}</p>
//                   <p className="text-sm font-bold truncate">{val}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="bg-white px-5 py-3 flex flex-wrap gap-x-6 gap-y-1.5 text-xs text-slate-500">
//             <span>
//               <span className="font-medium text-slate-700">E-way bill: </span>
//               {d.ewayBillNo || "—"}
//             </span>
//             <span>
//               <span className="font-medium text-slate-700">Party inv no: </span>
//               {d.partyInvoiceNo || "—"}
//             </span>
//             <span>
//               <span className="font-medium text-slate-700">
//                 Payment terms:{" "}
//               </span>
//               {d.paymentTerms || "—"}
//             </span>
//           </div>
//         </div>

//         {/* route + parties */}
//         <Section title="Route & parties" icon="📍">
//           <div className="flex items-center gap-2 bg-slate-50 rounded-xl px-4 py-3 mb-4 text-sm font-medium">
//             <span>{d.source}</span>
//             <span className="text-slate-300 flex-1 text-center text-lg">→</span>
//             <span>{d.destination}</span>
//           </div>
//           {[
//             { label: "Sender", name: sName, status: d.senderAmountStatus },
//             { label: "Receiver", name: rName, status: d.receiverAmountStatus },
//             {
//               label: "Transporter",
//               name: d.transporter || "—",
//               status: d.transporterAmountStatus,
//             },
//             { label: "Broker", name: d.broker || "—" },
//             { label: "Driver", name: drName },
//             { label: "Vehicle", name: vName },
//           ].map((p) => (
//             <div
//               key={p.label}
//               className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-0"
//             >
//               <div className="flex items-center gap-3">
//                 <div className="w-8 h-8 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center text-[10px] font-bold shrink-0">
//                   {initials(p.name)}
//                 </div>
//                 <div>
//                   <p className="text-[10px] text-slate-400">{p.label}</p>
//                   <p className="text-sm font-medium text-slate-800">{p.name}</p>
//                 </div>
//               </div>
//               {p.status && <StatusBadge status={p.status} />}
//             </div>
//           ))}
//         </Section>

//         {/* items */}
//         <Section title={`Items (${items.length})`} icon="📦">
//           {loading ? (
//             <div className="flex justify-center py-6">
//               <Spinner />
//             </div>
//           ) : items.length === 0 ? (
//             <p className="text-xs text-slate-400 text-center py-4">
//               No items recorded for this invoice
//             </p>
//           ) : (
//             <>
//               <table className="w-full text-xs">
//                 <thead>
//                   <tr className="border-b border-slate-100">
//                     {["#", "Description", "HSN", "UOM", "Qty", "Amount"].map(
//                       (h, i) => (
//                         <th
//                           key={h}
//                           className={`text-[10px] font-semibold text-slate-400 uppercase tracking-wide pb-2 ${i >= 4 ? "text-right" : "text-left"}`}
//                         >
//                           {h}
//                         </th>
//                       )
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {items.map((it, i) => (
//                     <tr
//                       key={it.id || i}
//                       className="border-b border-slate-50 last:border-0"
//                     >
//                       <td className="py-2 text-slate-400 pr-1">{i + 1}</td>
//                       <td className="py-2 font-medium text-slate-800 pr-2">
//                         {it.description || it.item_name || "—"}
//                       </td>
//                       <td className="py-2 text-slate-500 pr-2">
//                         {it.hsm_code || it.hsn_code || "—"}
//                       </td>
//                       <td className="py-2 text-slate-500 pr-2">
//                         {it.uom || it.unit || "—"}
//                       </td>
//                       <td className="py-2 text-right">
//                         {Number(
//                           it.qty || it.quantity || 0
//                         ).toLocaleString("en-IN")}
//                       </td>
//                       <td className="py-2 text-right font-semibold text-slate-800">
//                         {inr(it.amount || 0)}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               <div className="flex justify-between items-center pt-3 mt-1 border-t border-slate-100 text-sm">
//                 <span className="text-slate-500">
//                   Total · {itemQtyTotal.toLocaleString("en-IN")} units
//                 </span>
//                 <span className="font-bold text-slate-900">
//                   {inr(itemAmtTotal)}
//                 </span>
//               </div>
//             </>
//           )}
//         </Section>

//         {/* settlement */}
//         {settlement && (
//           <Section title="Settlement" icon="💳">
//             <div className="space-y-3 mb-4">
//               {(settlement.distributions || []).map((dist:any) => (
//                 <div
//                   key={dist.id}
//                   className="border border-slate-100 rounded-xl p-3"
//                 >
//                   <div className="flex items-center justify-between mb-1">
//                     <div className="flex items-center gap-2">
//                       <span
//                         className={`w-2 h-2 rounded-full ${dist.paid ? "bg-emerald-400" : "bg-amber-400"}`}
//                       />
//                       <div>
//                         <p className="text-sm font-medium">
//                           {dist.user_name || "—"}
//                         </p>
//                         <p className="text-[10px] text-slate-400 capitalize">
//                           {dist.user_type}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="text-right">
//                       <p className="text-sm font-semibold">
//                         {inr(dist.amount)}
//                       </p>
//                       <p
//                         className={`text-[10px] font-bold ${dist.paid ? "text-emerald-500" : "text-amber-500"}`}
//                       >
//                         {dist.paid ? "PAID" : "PENDING"}
//                       </p>
//                     </div>
//                   </div>
//                   {(dist.paymentRecords || []).map((p: any, idx: number) => (
             
//                     <div
//                       key={idx}
//                       className="flex justify-between text-[11px] text-slate-400 mt-1 pl-4"
//                     >
//                       <span>
//                         {p.paymentMode} · {fmtDate(p.date)}
//                       </span>
//                       <span className="font-medium">{inr(p.amount)}</span>
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//             <div className="grid grid-cols-3 gap-2">
//               {[
//                 ["Allocated", inr(allocTotal), "bg-slate-50 text-slate-700"],
//                 ["Paid", inr(paidTotal), "bg-emerald-50 text-emerald-700"],
//                 [
//                   "Outstanding",
//                   inr(allocTotal - paidTotal),
//                   "bg-amber-50 text-amber-700",
//                 ],
//               ].map(([label, val, cls]) => (
//                 <div key={label} className={`rounded-xl px-3 py-2.5 ${cls}`}>
//                   <p className="text-[10px] opacity-70">{label}</p>
//                   <p className="text-sm font-bold">{val}</p>
//                 </div>
//               ))}
//             </div>
//           </Section>
//         )}

//         {/* notes */}
//         {(d.subjects ||
//           d.itemsDescription ||
//           d.internalDescription ||
//           d.notes ||
//           d.link) && (
//           <Section title="Notes & documents" icon="📄">
//             {[
//               ["Subjects", d.subjects],
//               ["Items description", d.itemsDescription],
//               ["Internal note", d.internalDescription],
//               ["Notes", d.notes],
//               ["Payable by", d.paymentPayableBy],
//             ]
//               .filter(([, v]) => v)
//               .map(([label, val]) => (
//                 <div key={label} className="mb-3">
//                   <p className="text-[10px] text-slate-400 uppercase tracking-wide mb-1">
//                     {label}
//                   </p>
//                   <p className="text-sm text-slate-700">{val}</p>
//                 </div>
//               ))}
//             {d.link && (
//               <div className="pt-3 border-t border-slate-100 flex items-center gap-3">
//                 <button
//                   onClick={() => onViewPdf(items)}
//                   className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
//                 >
//                   View as PDF
//                 </button>
//                 <a
//                   href={`${API()}/${d.link.replace(/^\//, "")}`}
             
//                   target="_blank"
//                   rel="noreferrer"
//                   className="text-xs text-indigo-500 hover:text-indigo-600"
//                 >
//                   Open original link ↗
//                 </a>
//               </div>
//             )}
//           </Section>
//         )}
//       </div>
//     </div>
//   );
// }

// // --- Section Atom ---
// function Section({
//   title,
//   icon,
//   children,
// }: {
//   title: string;
//   icon: React.ReactNode;
//   children: React.ReactNode;
// }) {
//   return (
//     <div className="rounded-2xl border border-slate-100 bg-white shadow-sm overflow-hidden">
//       <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-100">
//         <span>{icon}</span>
//         <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
//       </div>
//       <div className="px-4 py-4">{children}</div>
//     </div>
//   );
// }

// // --- Main Dashboard ---
// const TABS = ["All", "Paid", "Pending", "Partial"];

// export default function AdminDashboard() {
//   const [companies, setCompanies] = useState<any[]>([]);
//   const [allInvoices, setAllInvoices] = useState<any[]>([]);
//   const [activeCompany, setActiveCompany] = useState<string>("all");
//   const [activeTab, setActiveTab] = useState<string>("All");
//   const [search, setSearch] = useState<string>("");
//   const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
//   const [editOpen, setEditOpen] = useState<boolean>(false);
//   const [pdfItems, setPdfItems] = useState<any[] | null>(null);
//   const [loadingCompanies, setLoadingCompanies] = useState<boolean>(true);
//   const [loadingInvoices, setLoadingInvoices] = useState<boolean>(true);
//   const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

//   // Load companies
//   useEffect(() => {
//     (async () => {
//       setLoadingCompanies(true);
//       const data = await fetchJSON(`${API()}/companyauth/companies`);
//       setCompanies(Array.isArray(data) ? data : []);
//       setLoadingCompanies(false);
//     })();
//   }, []);

//   // Load invoices
//   useEffect(() => {
//     (async () => {
//       setLoadingInvoices(true);
//       const data = await fetchJSON(`${API()}/invoiceapi/invoice`);
//       const mapped =
//         Array.isArray(data) ? data.map(mapInvoice).sort((a, b) => b.id - a.id) : [];
//       setAllInvoices(mapped);
//       if (mapped.length) setSelectedInvoice(mapped[0]);
//       setLoadingInvoices(false);
//     })();
//   }, []);

//   // Filtered invoices
//   const filteredInvoices = useMemo(() => {
//     let list = allInvoices;
//     // Filter by company
//     if (activeCompany !== "all") {
//       const co = companies.find((c) => String(c.id) === activeCompany);
//       if (co)
//         list = list.filter(
//           (inv) =>
//             inv.company === co.id ||
//             String(inv.companyId) === activeCompany
//         );
//     }
//     // Tab filter
//     if (activeTab !== "All") {
//       list = list.filter(
//         (inv) => classifyStatus(inv.paymentStatus) === activeTab.toLowerCase()
//       );
//     }
//     // Search filter
//     if (search.trim()) {
//       const q = search.toLowerCase();
//       list = list.filter((inv) =>
//         [
//           inv.invoiceNo,
//           inv.company,
//           inv.source,
//           inv.destination,
//           inv.transporter,
//           String(inv.id),
//         ].some((v) => (v || "").toLowerCase().includes(q))
//       );
//     }
//     return list;
//   }, [allInvoices, activeCompany, activeTab, search, companies]);

//   // Stats
//   const stats = useMemo(() => {
//     const src = activeCompany === "all" ? allInvoices : filteredInvoices;
//     return {
//       total: src.length,
//       totalValue: src.reduce((s, r) => s + r.invoiceValue, 0),
//       paid: src.filter((r) => classifyStatus(r.paymentStatus) === "paid").length,
//       awaiting: src.filter((r) => {
//         const c = classifyStatus(r.paymentStatus);
//         return c === "pending" || c === "partial";
//       }).length,
//     };
//   }, [allInvoices, filteredInvoices, activeCompany]);

//   // Tab counts
//   const tabCounts = useMemo(
//     () =>
//       TABS.map((t) => ({
//         label: t,
//         count:
//           t === "All"
//             ? filteredInvoices.length
//             : filteredInvoices.filter(
//                 (r) => classifyStatus(r.paymentStatus) === t.toLowerCase()
//               ).length,
//       })),
//     [filteredInvoices]
//   );

//   // Invoices count by company
//   const invCountByCompany = useMemo(() => {
//     const m: Record<string, number> = {};
//     allInvoices.forEach((inv) => {
//       const key = inv.companyId ? String(inv.companyId) : inv.company;
//       m[key] = (m[key] || 0) + 1;
//     });
//     return m;
//   }, [allInvoices]);

//   function handleSaveEdit(updated: any) {
//     setAllInvoices((prev) =>
//       prev.map((inv) =>
//         inv.id === updated.id ? { ...inv, ...updated } : inv
//       )
//     );
//     setSelectedInvoice((prev:any) =>
//       prev?.id === updated.id ? { ...prev, ...updated } : prev
//     );
//     setEditOpen(false);
//   }

//   // --- Render ---
//   return (
//     <div className="flex h-screen bg-slate-50 font-sans text-slate-800 overflow-hidden">
//       {/* ── company sidebar ── */}
//       <aside
//         className={`
//           fixed lg:static inset-y-0 left-0 flex flex-col
//           w-[220px] bg-white border-r border-slate-100
//           transition-transform duration-300
//           ${sidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"} lg:translate-x-0
//         `}
//       >
//         <div className="px-4 py-4 border-b border-slate-100">
//           <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest">
//             Companies
//           </p>
//         </div>
//         <div className="flex-1 overflow-y-auto py-2 px-2">
//           {/* all */}
//           <CoItem
//             label="All companies"
//             count={allInvoices.length}
//             active={activeCompany === "all"}
//             onClick={() => {
//               setActiveCompany("all");
//               setSidebarOpen(false);
//             }}
//           />
//           {loadingCompanies ? (
//             <div className="flex justify-center py-6">
//               <Spinner />
//             </div>
//           ) : (
//             companies.map((co) => (
//               <CoItem
//                 key={co.id}
//                 label={co.company_name}
//                 count={invCountByCompany[String(co.id)] || 0}
//                 active={activeCompany === String(co.id)}
//                 onClick={() => {
//                   setActiveCompany(String(co.id));
//                   setSidebarOpen(false);
//                 }}
//               />
//             ))
//           )}
//         </div>
//       </aside>
//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 z-30 bg-slate-900/40 lg:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}

//       {/* ── invoice list ── */}
//       <div className="w-[300px] min-w-[300px] flex flex-col bg-white border-r border-slate-100 overflow-hidden">
//         {/* mobile top bar */}
//         <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-100">
//           <button
//             className="lg:hidden w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center text-slate-500"
//             onClick={() => setSidebarOpen(true)}
//             aria-label="Open company list"
//           >
//             ☰
//           </button>
//           <div className="flex-1">
//             <p className="text-sm font-semibold text-slate-900">
//               {activeCompany === "all"
//                 ? "All invoices"
//                 : companies.find((c) => String(c.id) === activeCompany)
//                     ?.company_name || "Invoices"}
//             </p>
//             <p className="text-[11px] text-slate-400">
//               {filteredInvoices.length} invoice
//               {filteredInvoices.length !== 1 ? "s" : ""}
//             </p>
//           </div>
//         </div>

//         {/* search */}
//         <div className="px-3 py-2.5 border-b border-slate-100">
//           <div className="relative">
//             <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">
//               🔍
//             </span>
//             <input
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search invoices…"
//               className="w-full pl-8 pr-3 py-2 text-sm border border-slate-200 rounded-xl bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 placeholder-slate-400 transition"
//             />
//           </div>
//         </div>

//         {/* tabs */}
//         <div className="flex gap-1 px-3 py-2 border-b border-slate-100 overflow-x-auto">
//           {tabCounts.map((t) => (
//             <button
//               key={t.label}
//               onClick={() => setActiveTab(t.label)}
//               className={`flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition ${
//                 activeTab === t.label
//                   ? "bg-slate-900 text-white"
//                   : "text-slate-500 hover:bg-slate-100"
//               }`}
//             >
//               {t.label}
//               <span
//                 className={`text-[10px] rounded-full px-1.5 ${activeTab === t.label ? "bg-white/20" : "bg-slate-200 text-slate-600"}`}
//               >
//                 {t.count}
//               </span>
//             </button>
//           ))}
//         </div>

//         {/* list */}
//         <div className="flex-1 overflow-y-auto px-2 py-2 space-y-1.5">
//           {loadingInvoices ? (
//             <div className="flex justify-center py-12">
//               <Spinner size={22} />
//             </div>
//           ) : filteredInvoices.length === 0 ? (
//             <div className="flex flex-col items-center justify-center py-16 text-slate-300 gap-2">
//               <span className="text-3xl">📋</span>
//               <p className="text-xs">No invoices found</p>
//             </div>
//           ) : (
//             filteredInvoices.map((inv) => {
//               const cat = classifyStatus(inv.paymentStatus);
//               const isActive = selectedInvoice?.id === inv.id;
//               return (
//                 <button
//                   key={inv.id}
//                   onClick={() => setSelectedInvoice(inv)}
//                   className={`w-full text-left p-3.5 rounded-2xl border transition-all ${
//                     isActive
//                       ? "border-indigo-200 bg-indigo-50/60 ring-1 ring-indigo-100"
//                       : "border-slate-100 bg-white hover:border-slate-200 hover:shadow-sm"
//                   }`}
//                 >
//                   <div className="flex items-start justify-between mb-1.5">
//                     <p className="text-sm font-semibold text-slate-900 truncate">
//                       {inv.invoiceNo}
//                     </p>
//                     <StatusBadge status={inv.paymentStatus} />
//                   </div>
//                   <p className="text-[11px] text-slate-400 mb-1.5">
//                     {inv.source} → {inv.destination}
//                   </p>
//                   <div className="flex justify-between text-[11px] text-slate-400">
//                     <span>{fmtDate(inv.createdAt)}</span>
//                     <span className="font-semibold text-slate-700">
//                       {inr(inv.invoiceValue)}
//                     </span>
//                   </div>
//                   <div className="mt-2 w-full h-1 rounded-full bg-slate-100 overflow-hidden">
//                     <div
//                       className={`h-full rounded-full ${PROGRESS_COLOR[cat]} transition-all`}
//                       style={{ width: `${progressPct(cat)}%` }}
//                     />
//                   </div>
//                 </button>
//               );
//             })
//           )}
//         </div>
//       </div>

//       {/* ── main content ── */}
//       <main className="flex-1 flex flex-col overflow-hidden">
//         {/* stat cards */}
//         <div className="shrink-0 grid grid-cols-2 xl:grid-cols-4 gap-3 p-4 border-b border-slate-100 bg-white">
//           {[
//             {
//               label: "Total invoices",
//               value: stats.total,
//               sub: "in current view",
//               color: "text-indigo-600",
//               bg: "bg-indigo-50",
//             },
//             {
//               label: "Total value",
//               value: inr(stats.totalValue),
//               sub: "invoice value",
//               color: "text-violet-600",
//               bg: "bg-violet-50",
//             },
//             {
//               label: "Paid",
//               value: stats.paid,
//               sub: "fully settled",
//               color: "text-emerald-600",
//               bg: "bg-emerald-50",
//             },
//             {
//               label: "Awaiting payment",
//               value: stats.awaiting,
//               sub: "pending or partial",
//               color: "text-amber-600",
//               bg: "bg-amber-50",
//             },
//           ].map((s) => (
//             <div
//               key={s.label}
//               className="rounded-xl border border-slate-100 p-3.5"
//             >
//               <p className="text-xs text-slate-500 mb-1">{s.label}</p>
//               <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
//               <p className="text-[11px] text-slate-400 mt-0.5">{s.sub}</p>
//             </div>
//           ))}
//         </div>

//         {/* detail */}
//         <DetailPanel
//           key={selectedInvoice?.id}
//           invoice={selectedInvoice}
//           onEdit={() => setEditOpen(true)}
//           onViewPdf={(items) => setPdfItems(items)}
//         />
//       </main>

//       {/* overlays */}
//       {editOpen && selectedInvoice && (
//         <EditModal
//           invoice={selectedInvoice}
//           onClose={() => setEditOpen(false)}
//           onSave={handleSaveEdit}
//         />
//       )}
//       {pdfItems !== null && selectedInvoice && (
//         <PdfViewer
//           invoice={selectedInvoice}
//           items={pdfItems}
//           onClose={() => setPdfItems(null)}
//         />
//       )}
//     </div>
//   );
// }

// // --- Company List Item Atom ---
// function CoItem({
//   label,
//   count,
//   active,
//   onClick,
// }: {
//   label: string;
//   count: number;
//   active: boolean;
//   onClick: () => void;
// }) {
//   return (
//     <button
//       onClick={onClick}
//       className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-left transition ${
//         active
//           ? "bg-indigo-50 text-indigo-700"
//           : "text-slate-600 hover:bg-slate-50"
//       }`}
//     >
//       <div
//         className={`w-7 h-7 rounded-lg flex items-center justify-center text-[10px] font-bold shrink-0 ${
//           active
//             ? "bg-indigo-100 text-indigo-700"
//             : "bg-slate-100 text-slate-500"
//         }`}
//       >
//         {initials(label)}
//       </div>
//       <div className="min-w-0 flex-1">
//         <p className="text-xs font-semibold truncate">{label}</p>
//         <p className="text-[10px] opacity-60">
//           {count} invoice{count !== 1 ? "s" : ""}
//         </p>
//       </div>
//     </button>
//   );
// }

import { useEffect, useMemo, useState, useCallback, useRef } from "react";

// ─── helpers ────────────────────────────────────────────────────────────────

const API = () => process.env.REACT_APP_API_URL || "";

const inr = (n: number | string): string =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

const fmtDate = (v: string | number | Date | null | undefined): string => {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d.getTime())
    ? String(v)
    : d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
};

const initials = (v: string) => {
  const s = String(v || "").trim();
  if (!s || s === "—") return "??";
  const p = s.split(" ").filter(Boolean);
  return (
    (p[0]?.[0] || "") +
    (p.length > 1 ? p[p.length - 1]?.[0] : p[0]?.[1] || "")
  ).toUpperCase();
};

const classifyStatus = (s: string): "paid" | "partial" | "pending" | "unknown" => {
  const v = (s || "").toLowerCase();
  if (v.includes("partial")) return "partial";
  if (v.includes("paid") || v.includes("clear") || v.includes("settle")) return "paid";
  if (v.includes("pend") || v.includes("due") || v.includes("unpaid")) return "pending";
  return "unknown";
};

const STATUS_STYLES: Record<string, string> = {
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partial: "bg-blue-50 text-blue-700 border-blue-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  unknown: "bg-slate-100 text-slate-500 border-slate-200",
};

const STATUS_DOT: Record<string, string> = {
  paid: "bg-emerald-400",
  partial: "bg-blue-400",
  pending: "bg-amber-400",
  unknown: "bg-slate-400",
};

const PROGRESS_COLOR: Record<string, string> = {
  paid: "bg-emerald-400",
  partial: "bg-blue-400",
  pending: "bg-amber-400",
  unknown: "bg-slate-200",
};

const progressPct = (c: string): number => {
  switch (c) {
    case "paid": return 100;
    case "partial": return 55;
    case "pending": return 15;
    default: return 0;
  }
};

async function fetchJSON(url: string): Promise<any | null> {
  try {
    const r = await fetch(url);
    if (!r.ok) return null;
    return await r.json();
  } catch {
    return null;
  }
}

function mapInvoice(r: any) {
  return {
    id: r.id,
    invoiceNo: r["InvoiceNo."] || `INV-${r.id}`,
    ewayBillNo: r.EWAYBILLNO || null,
    partyInvoiceNo: r.party_invoice_no || null,
    company: r.company || "—",
    companyId: r.company_id || null,
    sender: r.sender || null,
    senderId: r.sender_id || null,
    receiver: r.receiver || null,
    receiverId: r.receiver_id || null,
    transporter: r.transporter || null,
    transporterId: r.transporter_id || null,
    driver: r.driver || null,
    driverId: r.driver_id || null,
    vehicle: r.vehicles || null,
    vehicleId: r.vehicle_id || null,
    broker: r.broker || null,
    paymentTerms: r.payment || null,
    paymentPayableBy: r.paymentPayableConsignor || null,
    source: r.source || "—",
    destination: r.destination || "—",
    paymentStatus: r.paymentStatus || null,
    senderAmountStatus: r.senderAmountStatatus || null,
    receiverAmountStatus: r.receiverAmountStatatus || null,
    transporterAmountStatus: r.transporterAmountStatatus || null,
    itemsDescription: r.ItemsDescription || null,
    subjects: r.subjects || null,
    link: r.link || null,
    invoiceValue: Number(r.invoice_value || 0),
    internalDescription: r.internalDescription || null,
    notes: r.notesitems || null,
    createdAt: r.created_at || null,
  };
}

// ─── Atoms ──────────────────────────────────────────────────────────────────

function Spinner({ size = 16 }: { size?: number }) {
  return (
    <svg
      className="animate-spin text-slate-400"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" className="opacity-20" />
      <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

function StatusBadge({ status }: { status: string }) {
  const cat = classifyStatus(status || "");
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] sm:text-[11px] font-semibold px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full border capitalize whitespace-nowrap ${STATUS_STYLES[cat]}`}>
      <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${STATUS_DOT[cat]}`} />
      {status && status.trim() ? status : "Not set"}
    </span>
  );
}

function Section({
  title,
  icon,
  children,
}: {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-xl sm:rounded-2xl border border-slate-100 bg-white shadow-sm overflow-hidden">
      <div className="flex items-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border-b border-slate-100">
        <span className="text-base">{icon}</span>
        <h3 className="text-xs sm:text-sm font-semibold text-slate-800">{title}</h3>
      </div>
      <div className="px-3 sm:px-4 py-3 sm:py-4">{children}</div>
    </div>
  );
}

function CoItem({
  label,
  count,
  active,
  onClick,
}: {
  label: string;
  count: number;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-2 sm:gap-2.5 px-2.5 sm:px-3 py-2 sm:py-2.5 rounded-xl text-left transition active:scale-[0.98] ${
        active ? "bg-indigo-50 text-indigo-700" : "text-slate-600 hover:bg-slate-50"
      }`}
    >
      <div className={`w-6 h-6 sm:w-7 sm:h-7 rounded-lg flex items-center justify-center text-[9px] sm:text-[10px] font-bold shrink-0 ${
        active ? "bg-indigo-100 text-indigo-700" : "bg-slate-100 text-slate-500"
      }`}>
        {initials(label)}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] sm:text-xs font-semibold truncate">{label}</p>
        <p className="text-[9px] sm:text-[10px] opacity-60">{count} invoice{count !== 1 ? "s" : ""}</p>
      </div>
      {active && <span className="w-1.5 h-1.5 rounded-full bg-indigo-400 shrink-0" />}
    </button>
  );
}

// ─── PDF Viewer ──────────────────────────────────────────────────────────────

type PdfViewerProps = {
  invoice: any;
  items: Array<{ amount?: number | string; qty?: number | string; quantity?: number | string }>;
  onClose: () => void;
};

function PdfViewer({ invoice, items, onClose }: PdfViewerProps) {
  const itemAmtTotal = items.reduce((s: number, i) => s + Number(i.amount || 0), 0);
  const itemQtyTotal = items.reduce((s: number, i) => s + Number(i.qty || (i as any).quantity || 0), 0);

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-slate-900/60 backdrop-blur-sm">
      <div className="bg-white border-b border-slate-200 px-3 sm:px-5 h-12 sm:h-14 flex items-center justify-between shrink-0 gap-2">
        <p className="text-xs sm:text-sm font-semibold text-slate-900 truncate">
          Invoice — {invoice.invoiceNo}
        </p>
        <div className="flex gap-1.5 sm:gap-2 shrink-0">
          <button
            onClick={() => window.print()}
            className="inline-flex items-center gap-1 text-[11px] sm:text-xs font-semibold px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
          >
            🖨️ <span className="hidden sm:inline">Print / Save PDF</span>
            <span className="sm:hidden">Print</span>
          </button>
          <button
            onClick={onClose}
            className="inline-flex items-center gap-1 text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
          >
            ✕ <span className="hidden sm:inline">Close</span>
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-auto bg-slate-100 py-4 sm:py-8 px-2 sm:px-4 flex justify-center">
        <div
          className="bg-white w-full max-w-[800px] p-5 sm:p-8 md:p-12 shadow-xl rounded-lg text-[12px] sm:text-[13px] text-slate-800"
          style={{ minHeight: 900 }}
        >
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 mb-6 sm:mb-8">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">INVOICE</h1>
              <p className="text-slate-500">{invoice.invoiceNo}</p>
            </div>
            <div className="sm:text-right">
              <p className="font-semibold text-slate-800">{invoice.company}</p>
              <p className="text-slate-500 text-xs mt-0.5">Issued {fmtDate(invoice.createdAt)}</p>
              <div className="mt-1"><StatusBadge status={invoice.paymentStatus} /></div>
            </div>
          </div>

          <hr className="border-slate-200 mb-4 sm:mb-6" />

          <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">
            Consignment details
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">
            {[
              ["E-way bill no", invoice.ewayBillNo],
              ["Party invoice no", invoice.partyInvoiceNo],
              ["Payment terms", invoice.paymentTerms],
              ["Source", invoice.source],
              ["Destination", invoice.destination],
              ["Payable by", invoice.paymentPayableBy],
            ].map(([label, val]) => (
              <div key={label}>
                <p className="text-[10px] text-slate-400 mb-0.5">{label}</p>
                <p className="font-medium text-xs sm:text-sm">{val || "—"}</p>
              </div>
            ))}
          </div>

          <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">Parties</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 mb-4 sm:mb-6">
            {[
              ["Sender / Consignor", invoice.sender],
              ["Receiver / Consignee", invoice.receiver],
              ["Transporter", invoice.transporter],
              ["Driver", invoice.driver],
              ["Vehicle", invoice.vehicle],
              ["Broker", invoice.broker],
            ].map(([label, val]) => (
              <div key={label}>
                <p className="text-[10px] text-slate-400 mb-0.5">{label}</p>
                <p className="font-medium text-xs sm:text-sm">{val || "—"}</p>
              </div>
            ))}
          </div>

          <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">Items</p>
          <div className="overflow-x-auto -mx-1">
            <table className="w-full border-collapse mb-4 sm:mb-6 min-w-[480px]">
              <thead>
                <tr className="bg-slate-50">
                  {["#", "Description", "HSN", "UOM", "Qty", "Amount (INR)"].map((h, i) => (
                    <th
                      key={h}
                      className={`text-left text-[9px] sm:text-[10px] font-semibold text-slate-500 uppercase tracking-wide px-2 sm:px-3 py-2 border border-slate-200 ${i >= 4 ? "text-right" : ""}`}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="px-3 py-4 text-center text-slate-400 border border-slate-200">
                      No items recorded
                    </td>
                  </tr>
                ) : (
                  items.map((it: any, i) => (
                    <tr key={i}>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 text-slate-400">{i + 1}</td>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 font-medium">{it.description || it.item_name || "—"}</td>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 text-slate-500">{it.hsm_code || it.hsn_code || "—"}</td>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 text-slate-500">{it.uom || it.unit || "—"}</td>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 text-right">{Number(it.qty || it.quantity || 0).toLocaleString("en-IN")}</td>
                      <td className="px-2 sm:px-3 py-2 border border-slate-200 text-right font-medium">{inr(it.amount || 0)}</td>
                    </tr>
                  ))
                )}
                <tr className="bg-slate-50 font-semibold">
                  <td colSpan={4} className="px-2 sm:px-3 py-2 border border-slate-200 text-right text-slate-500 text-[9px] sm:text-[10px] uppercase tracking-wide">Total</td>
                  <td className="px-2 sm:px-3 py-2 border border-slate-200 text-right">{itemQtyTotal.toLocaleString("en-IN")}</td>
                  <td className="px-2 sm:px-3 py-2 border border-slate-200 text-right">{inr(itemAmtTotal)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="flex justify-end mb-6 sm:mb-8">
            <div className="w-full sm:w-64 border border-slate-200 rounded-lg overflow-hidden">
              {[["Items total", inr(itemAmtTotal)], ["Invoice value", inr(invoice.invoiceValue)]].map(([label, val]) => (
                <div key={label} className="flex justify-between items-center px-3 sm:px-4 py-2 sm:py-2.5 border-b border-slate-100 last:border-0">
                  <span className="text-slate-500 text-xs">{label}</span>
                  <span className="font-semibold text-slate-800">{val}</span>
                </div>
              ))}
            </div>
          </div>

          {(invoice.subjects || invoice.notes || invoice.internalDescription) && (
            <div className="mb-6 sm:mb-8">
              <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold mb-3">Notes</p>
              <div className="bg-slate-50 rounded-lg p-3 sm:p-4 space-y-2 text-xs sm:text-sm text-slate-700">
                {invoice.subjects && <p>{invoice.subjects}</p>}
                {invoice.internalDescription && <p>{invoice.internalDescription}</p>}
                {invoice.notes && <p>{invoice.notes}</p>}
              </div>
            </div>
          )}

          <div className="flex justify-end mt-8 sm:mt-12">
            <div className="text-center w-36 sm:w-48">
              <div className="h-10 sm:h-12 border-b border-slate-400 mb-2" />
              <p className="text-xs text-slate-500">Authorised signatory</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Edit Modal ──────────────────────────────────────────────────────────────

function EditModal({
  invoice,
  onClose,
  onSave,
}: {
  invoice: any;
  onClose: () => void;
  onSave: (form: any) => void;
}) {
  const [form, setForm] = useState({ ...invoice });
  const [saving, setSaving] = useState(false);

  const field = (label: string, key: string, type: string = "text") => (
    <div>
      <label className="block text-[11px] sm:text-xs text-slate-500 mb-1">{label}</label>
      {type === "textarea" ? (
        <textarea
          className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
          rows={2}
          value={form[key] || ""}
          onChange={(e) => setForm((f: any) => ({ ...f, [key]: e.target.value }))}
        />
      ) : type === "select-status" ? (
        <select
          className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
          value={form[key] || ""}
          onChange={(e) => setForm((f: any) => ({ ...f, [key]: e.target.value }))}
        >
          {["Paid", "Partial", "Pending", "Unpaid", "Settled", "Cleared"].map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          className="w-full border border-slate-200 rounded-lg px-3 py-2 text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 transition"
          value={form[key] || ""}
          onChange={(e) => setForm((f: any) => ({ ...f, [key]: e.target.value }))}
        />
      )}
    </div>
  );

  async function handleSave() {
    setSaving(true);
    try {
      const r = await fetch(`${API()}/invoiceapi/invoice/${invoice.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (r.ok) onSave(form);
      else alert("Save failed — check API.");
    } catch {
      onSave(form);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/50 backdrop-blur-sm p-0 sm:p-4">
      <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl border border-slate-100 w-full sm:max-w-xl flex flex-col max-h-[92vh] sm:max-h-[90vh]">
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 sm:py-4 border-b border-slate-100">
          <h2 className="text-xs sm:text-sm font-semibold text-slate-900 truncate pr-2">
            Edit — {invoice.invoiceNo}
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400 transition shrink-0"
          >
            ✕
          </button>
        </div>

        <div className="overflow-y-auto flex-1 p-4 sm:p-5 space-y-3 sm:space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {field("Invoice No", "invoiceNo")}
            {field("E-way bill no", "ewayBillNo")}
            {field("Source", "source")}
            {field("Destination", "destination")}
            {field("Sender / Consignor", "sender")}
            {field("Receiver / Consignee", "receiver")}
            {field("Transporter", "transporter")}
            {field("Driver", "driver")}
            {field("Vehicle", "vehicle")}
            {field("Broker", "broker")}
            {field("Invoice value (INR)", "invoiceValue", "number")}
            {field("Payment status", "paymentStatus", "select-status")}
            {field("Payment terms", "paymentTerms")}
            {field("Party invoice no", "partyInvoiceNo")}
          </div>
          {field("Subjects", "subjects")}
          {field("Internal notes", "internalDescription", "textarea")}
          {field("Notes", "notes", "textarea")}
        </div>

        <div className="flex justify-end gap-2 px-4 sm:px-5 py-3 sm:py-4 border-t border-slate-100">
          <button
            onClick={onClose}
            className="px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
          >
            Cancel
          </button>
          <button
            disabled={saving}
            onClick={handleSave}
            className="px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm bg-indigo-600 text-white font-semibold hover:bg-indigo-700 disabled:opacity-50 transition flex items-center gap-1.5"
          >
            {saving ? <Spinner size={14} /> : "✓"} Save changes
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Name Resolver ───────────────────────────────────────────────────────────

function useNameResolver() {
  const cache = useRef<Record<string, string>>({});
  const resolve = useCallback(async (type: string, id: any, fallback: any) => {
    if (fallback && String(fallback).trim() && fallback !== "—") return fallback;
    if (!id) return "—";
    const key = `${type}_${id}`;
    if (cache.current[key]) return cache.current[key];
    let name = "—";
    if (type === "user") {
      const d = await fetchJSON(`${API()}/auth/user/${id}`);
      name = d?.name || `User #${id}`;
    } else if (type === "driver") {
      const d = await fetchJSON(`${API()}/auth/drivers/${id}`);
      name = d?.name || `Driver #${id}`;
    } else if (type === "vehicle") {
      const d = await fetchJSON(`${API()}/auth/vehicles/${id}`);
      name = d?.vehicle_number || d?.registration_number || `Vehicle #${id}`;
    }
    cache.current[key] = name;
    return name;
  }, []);
  return resolve;
}

// ─── Detail Panel ────────────────────────────────────────────────────────────

function DetailPanel({
  invoice,
  onEdit,
  onViewPdf,
  onBack,
}: {
  invoice: any;
  onEdit: () => void;
  onViewPdf: (items: any[]) => void;
  onBack?: () => void;
}) {
  const resolve = useNameResolver();
  const [names, setNames] = useState<null | {
    senderName?: string;
    receiverName?: string;
    driverName?: string;
    vehicleName?: string;
  }>(null);
  const [items, setItems] = useState<any[]>([]);
  const [settlement, setSettlement] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!invoice) return;
    let mounted = true;
    setLoading(true);
    setItems([]);
    setSettlement(null);
    setNames(null);

    (async () => {
      const [rawItems, settle] = await Promise.all([
        fetchJSON(`${API()}/invoiceapi/invoice_items/invoice/${invoice.id}`).catch(() => null),
        fetchJSON(`${API()}/settlment/${invoice.id}`).catch(() => null),
      ]);

      const [senderName, receiverName, driverName, vehicleName] = await Promise.all([
        resolve("user", invoice.senderId, invoice.sender),
        resolve("user", invoice.receiverId, invoice.receiver),
        resolve("driver", invoice.driverId, invoice.driver),
        resolve("vehicle", invoice.vehicleId, invoice.vehicle),
      ]);

      if (!mounted) return;
      setItems(Array.isArray(rawItems) ? rawItems : []);
      setSettlement(settle?.id ? settle : null);
      setNames({ senderName, receiverName, driverName, vehicleName });
      setLoading(false);
    })();

    return () => { mounted = false; };
  }, [invoice?.id]);

  if (!invoice) {
    return (
      <div className="flex-1 hidden md:flex flex-col items-center justify-center text-slate-300 gap-3">
        <svg width="52" height="52" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
        </svg>
        <p className="text-sm">Select an invoice to view details</p>
      </div>
    );
  }

  const itemAmtTotal = items.reduce((s, i) => s + Number(i.amount || 0), 0);
  const itemQtyTotal = items.reduce((s, i) => s + Number(i.qty || i.quantity || 0), 0);
  const allocTotal = Number(settlement?.total_allocated || 0);
  const paidTotal = Number(settlement?.total_paid || 0);

  const d = invoice;
  const sName = names?.senderName || d.sender || "—";
  const rName = names?.receiverName || d.receiver || "—";
  const drName = names?.driverName || d.driver || "—";
  const vName = names?.vehicleName || d.vehicle || "—";

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      {/* action bar */}
      <div className="shrink-0 flex items-center gap-1.5 sm:gap-2 px-3 sm:px-5 py-2.5 sm:py-3 border-b border-slate-100 bg-white">
        {/* Back button — mobile only */}
        {onBack && (
          <button
            onClick={onBack}
            className="md:hidden inline-flex items-center gap-1 text-xs font-medium px-2.5 py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition mr-1"
          >
            ← Back
          </button>
        )}
        <button
          onClick={onEdit}
          className="inline-flex items-center gap-1 text-[11px] sm:text-xs font-medium px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
        >
          ✎ <span className="hidden sm:inline">Edit invoice</span>
          <span className="sm:hidden">Edit</span>
        </button>
        <button
          onClick={() => onViewPdf(items)}
          className="inline-flex items-center gap-1 text-[11px] sm:text-xs font-semibold px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
        >
          ↓ <span className="hidden sm:inline">View / Print PDF</span>
          <span className="sm:hidden">PDF</span>
        </button>
        <span className="flex-1" />
        <span className="text-[10px] sm:text-xs text-slate-400 font-medium truncate max-w-[100px] sm:max-w-none">{d.invoiceNo}</span>
      </div>

      {/* scrollable content */}
      <div className="flex-1 overflow-y-auto px-3 sm:px-5 py-3 sm:py-5 space-y-3 sm:space-y-4">
        {/* hero card */}
        <div className="rounded-xl sm:rounded-2xl overflow-hidden border border-slate-100 shadow-sm">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 p-4 sm:p-5 text-white">
            <div className="flex items-start justify-between gap-2 mb-3 sm:mb-4">
              <div className="min-w-0">
                <p className="text-[10px] uppercase tracking-widest text-slate-400 mb-0.5">Invoice</p>
                <h2 className="text-xl sm:text-2xl font-bold truncate">{d.invoiceNo}</h2>
                <p className="text-[11px] sm:text-xs text-slate-400 mt-0.5 truncate">
                  {d.company} · {fmtDate(d.createdAt)}
                </p>
              </div>
              <div className="shrink-0 mt-1"><StatusBadge status={d.paymentStatus} /></div>
            </div>
            <div className="grid grid-cols-3 gap-1.5 sm:gap-2">
              {[
                ["Items", loading ? "…" : items.length],
                ["Items total", loading ? "…" : inr(itemAmtTotal)],
                ["Inv. value", inr(d.invoiceValue)],
              ].map(([label, val]) => (
                <div key={label} className="rounded-lg sm:rounded-xl bg-white/10 backdrop-blur px-2 sm:px-3 py-2 sm:py-2.5">
                  <p className="text-[9px] sm:text-[10px] text-slate-400 mb-0.5">{label}</p>
                  <p className="text-xs sm:text-sm font-bold truncate">{val}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white px-3 sm:px-5 py-2.5 sm:py-3 flex flex-wrap gap-x-4 sm:gap-x-6 gap-y-1 text-[11px] sm:text-xs text-slate-500">
            <span><span className="font-medium text-slate-700">E-way: </span>{d.ewayBillNo || "—"}</span>
            <span><span className="font-medium text-slate-700">Party: </span>{d.partyInvoiceNo || "—"}</span>
            <span><span className="font-medium text-slate-700">Terms: </span>{d.paymentTerms || "—"}</span>
          </div>
        </div>

        {/* route + parties */}
        <Section title="Route & parties" icon="📍">
          <div className="flex items-center gap-2 bg-slate-50 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 mb-3 sm:mb-4 text-xs sm:text-sm font-medium">
            <span className="truncate">{d.source}</span>
            <span className="text-slate-300 flex-1 text-center text-base sm:text-lg shrink-0">→</span>
            <span className="truncate">{d.destination}</span>
          </div>
          {[
            { label: "Sender", name: sName, status: d.senderAmountStatus },
            { label: "Receiver", name: rName, status: d.receiverAmountStatus },
            { label: "Transporter", name: d.transporter || "—", status: d.transporterAmountStatus },
            { label: "Broker", name: d.broker || "—" },
            { label: "Driver", name: drName },
            { label: "Vehicle", name: vName },
          ].map((p) => (
            <div key={p.label} className="flex items-center justify-between py-2 sm:py-2.5 border-b border-slate-100 last:border-0 gap-2">
              <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center text-[9px] sm:text-[10px] font-bold shrink-0">
                  {initials(p.name)}
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] text-slate-400">{p.label}</p>
                  <p className="text-xs sm:text-sm font-medium text-slate-800 truncate">{p.name}</p>
                </div>
              </div>
              {p.status && (
                <div className="shrink-0"><StatusBadge status={p.status} /></div>
              )}
            </div>
          ))}
        </Section>

        {/* items */}
        <Section title={`Items (${items.length})`} icon="📦">
          {loading ? (
            <div className="flex justify-center py-6"><Spinner /></div>
          ) : items.length === 0 ? (
            <p className="text-xs text-slate-400 text-center py-4">No items recorded for this invoice</p>
          ) : (
            <>
              <div className="overflow-x-auto -mx-1">
                <table className="w-full text-xs min-w-[420px]">
                  <thead>
                    <tr className="border-b border-slate-100">
                      {["#", "Description", "HSN", "UOM", "Qty", "Amount"].map((h, i) => (
                        <th key={h} className={`text-[9px] sm:text-[10px] font-semibold text-slate-400 uppercase tracking-wide pb-2 ${i >= 4 ? "text-right" : "text-left"}`}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((it: any, i) => (
                      <tr key={it.id || i} className="border-b border-slate-50 last:border-0">
                        <td className="py-2 text-slate-400 pr-1">{i + 1}</td>
                        <td className="py-2 font-medium text-slate-800 pr-2 max-w-[120px] truncate">{it.description || it.item_name || "—"}</td>
                        <td className="py-2 text-slate-500 pr-2">{it.hsm_code || it.hsn_code || "—"}</td>
                        <td className="py-2 text-slate-500 pr-2">{it.uom || it.unit || "—"}</td>
                        <td className="py-2 text-right">{Number(it.qty || it.quantity || 0).toLocaleString("en-IN")}</td>
                        <td className="py-2 text-right font-semibold text-slate-800">{inr(it.amount || 0)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-between items-center pt-2.5 mt-1 border-t border-slate-100 text-xs sm:text-sm">
                <span className="text-slate-500">Total · {itemQtyTotal.toLocaleString("en-IN")} units</span>
                <span className="font-bold text-slate-900">{inr(itemAmtTotal)}</span>
              </div>
            </>
          )}
        </Section>

        {/* settlement */}
        {settlement && (
          <Section title="Settlement" icon="💳">
            <div className="space-y-2.5 sm:space-y-3 mb-3 sm:mb-4">
              {(settlement.distributions || []).map((dist: any) => (
                <div key={dist.id} className="border border-slate-100 rounded-xl p-2.5 sm:p-3">
                  <div className="flex items-center justify-between mb-1 gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <span className={`w-2 h-2 rounded-full shrink-0 ${dist.paid ? "bg-emerald-400" : "bg-amber-400"}`} />
                      <div className="min-w-0">
                        <p className="text-xs sm:text-sm font-medium truncate">{dist.user_name || "—"}</p>
                        <p className="text-[9px] sm:text-[10px] text-slate-400 capitalize">{dist.user_type}</p>
                      </div>
                    </div>
                    <div className="text-right shrink-0">
                      <p className="text-xs sm:text-sm font-semibold">{inr(dist.amount)}</p>
                      <p className={`text-[9px] sm:text-[10px] font-bold ${dist.paid ? "text-emerald-500" : "text-amber-500"}`}>
                        {dist.paid ? "PAID" : "PENDING"}
                      </p>
                    </div>
                  </div>
                  {(dist.paymentRecords || []).map((p: any, idx: number) => (
                    <div key={idx} className="flex justify-between text-[10px] sm:text-[11px] text-slate-400 mt-1 pl-4">
                      <span>{p.paymentMode} · {fmtDate(p.date)}</span>
                      <span className="font-medium">{inr(p.amount)}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="grid grid-cols-3 gap-1.5 sm:gap-2">
              {[
                ["Allocated", inr(allocTotal), "bg-slate-50 text-slate-700"],
                ["Paid", inr(paidTotal), "bg-emerald-50 text-emerald-700"],
                ["Outstanding", inr(allocTotal - paidTotal), "bg-amber-50 text-amber-700"],
              ].map(([label, val, cls]) => (
                <div key={label} className={`rounded-lg sm:rounded-xl px-2 sm:px-3 py-2 sm:py-2.5 ${cls}`}>
                  <p className="text-[9px] sm:text-[10px] opacity-70">{label}</p>
                  <p className="text-[11px] sm:text-sm font-bold">{val}</p>
                </div>
              ))}
            </div>
          </Section>
        )}

        {/* notes */}
        {(d.subjects || d.itemsDescription || d.internalDescription || d.notes || d.link) && (
          <Section title="Notes & documents" icon="📄">
            {[
              ["Subjects", d.subjects],
              ["Items description", d.itemsDescription],
              ["Internal note", d.internalDescription],
              ["Notes", d.notes],
              ["Payable by", d.paymentPayableBy],
            ]
              .filter(([, v]) => v)
              .map(([label, val]) => (
                <div key={label} className="mb-2.5 sm:mb-3">
                  <p className="text-[9px] sm:text-[10px] text-slate-400 uppercase tracking-wide mb-1">{label}</p>
                  <p className="text-xs sm:text-sm text-slate-700">{val}</p>
                </div>
              ))}
            {d.link && (
              <div className="pt-2.5 sm:pt-3 border-t border-slate-100 flex flex-wrap items-center gap-2 sm:gap-3">
                <button
                  onClick={() => onViewPdf(items)}
                  className="inline-flex items-center gap-1 text-[11px] sm:text-xs font-semibold px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition"
                >
                  View as PDF
                </button>
                <a
                  href={`${API()}/${d.link.replace(/^\//, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-[11px] sm:text-xs text-indigo-500 hover:text-indigo-600"
                >
                  Open original ↗
                </a>
              </div>
            )}
          </Section>
        )}

        {/* bottom padding for mobile */}
        <div className="h-4 sm:h-0" />
      </div>
    </div>
  );
}

// ─── Main Dashboard ──────────────────────────────────────────────────────────

const TABS = ["All", "Paid", "Pending", "Partial"];

// Mobile view states
type MobileView = "list" | "detail";

export default function AdminDashboard() {
  const [companies, setCompanies] = useState<any[]>([]);
  const [allInvoices, setAllInvoices] = useState<any[]>([]);
  const [activeCompany, setActiveCompany] = useState<string>("all");
  const [activeTab, setActiveTab] = useState<string>("All");
  const [search, setSearch] = useState<string>("");
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [pdfItems, setPdfItems] = useState<any[] | null>(null);
  const [loadingCompanies, setLoadingCompanies] = useState<boolean>(true);
  const [loadingInvoices, setLoadingInvoices] = useState<boolean>(true);
  const [companySidebarOpen, setCompanySidebarOpen] = useState<boolean>(false);
  // Mobile navigation state
  const [mobileView, setMobileView] = useState<MobileView>("list");

  useEffect(() => {
    (async () => {
      setLoadingCompanies(true);
      const data = await fetchJSON(`${API()}/companyauth/companies`);
      setCompanies(Array.isArray(data) ? data : []);
      setLoadingCompanies(false);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoadingInvoices(true);
      const data = await fetchJSON(`${API()}/invoiceapi/invoice`);
      const mapped = Array.isArray(data)
        ? data.map(mapInvoice).sort((a, b) => b.id - a.id)
        : [];
      setAllInvoices(mapped);
      if (mapped.length) setSelectedInvoice(mapped[0]);
      setLoadingInvoices(false);
    })();
  }, []);

  const filteredInvoices = useMemo(() => {
    let list = allInvoices;
    if (activeCompany !== "all") {
      const co = companies.find((c) => String(c.id) === activeCompany);
      if (co)
        list = list.filter(
          (inv) => inv.company === co.id || String(inv.companyId) === activeCompany
        );
    }
    if (activeTab !== "All") {
      list = list.filter(
        (inv) => classifyStatus(inv.paymentStatus) === activeTab.toLowerCase()
      );
    }
    if (search.trim()) {
      const q = search.toLowerCase();
      list = list.filter((inv) =>
        [inv.invoiceNo, inv.company, inv.source, inv.destination, inv.transporter, String(inv.id)].some(
          (v) => (v || "").toLowerCase().includes(q)
        )
      );
    }
    return list;
  }, [allInvoices, activeCompany, activeTab, search, companies]);

  const stats = useMemo(() => {
    const src = activeCompany === "all" ? allInvoices : filteredInvoices;
    return {
      total: src.length,
      totalValue: src.reduce((s, r) => s + r.invoiceValue, 0),
      paid: src.filter((r) => classifyStatus(r.paymentStatus) === "paid").length,
      awaiting: src.filter((r) => {
        const c = classifyStatus(r.paymentStatus);
        return c === "pending" || c === "partial";
      }).length,
    };
  }, [allInvoices, filteredInvoices, activeCompany]);

  const tabCounts = useMemo(
    () =>
      TABS.map((t) => ({
        label: t,
        count:
          t === "All"
            ? filteredInvoices.length
            : filteredInvoices.filter(
                (r) => classifyStatus(r.paymentStatus) === t.toLowerCase()
              ).length,
      })),
    [filteredInvoices]
  );

  const invCountByCompany = useMemo(() => {
    const m: Record<string, number> = {};
    allInvoices.forEach((inv) => {
      const key = inv.companyId ? String(inv.companyId) : inv.company;
      m[key] = (m[key] || 0) + 1;
    });
    return m;
  }, [allInvoices]);

  function handleSaveEdit(updated: any) {
    setAllInvoices((prev) =>
      prev.map((inv) => (inv.id === updated.id ? { ...inv, ...updated } : inv))
    );
    setSelectedInvoice((prev: any) =>
      prev?.id === updated.id ? { ...prev, ...updated } : prev
    );
    setEditOpen(false);
  }

  function handleSelectInvoice(inv: any) {
    setSelectedInvoice(inv);
    setMobileView("detail"); // Switch to detail view on mobile
  }

  return (
    <div className="flex h-screen bg-slate-50 font-sans text-slate-800 overflow-hidden">

      {/* ── Company sidebar overlay (mobile) ── */}
      {companySidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-slate-900/40 lg:hidden"
          onClick={() => setCompanySidebarOpen(false)}
        />
      )}

      {/* ── Company sidebar ── */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-50 flex flex-col
          w-[200px] sm:w-[220px] bg-white border-r border-slate-100
          transition-transform duration-300
          ${companySidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full"}
          lg:translate-x-0 lg:shadow-none
        `}
      >
        <div className="px-3 sm:px-4 py-3 sm:py-4 border-b border-slate-100 flex items-center justify-between">
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest">Companies</p>
          <button
            onClick={() => setCompanySidebarOpen(false)}
            className="lg:hidden w-6 h-6 flex items-center justify-center text-slate-400 hover:text-slate-600"
          >
            ✕
          </button>
        </div>
        <div className="flex-1 overflow-y-auto py-2 px-1.5 sm:px-2">
          <CoItem
            label="All companies"
            count={allInvoices.length}
            active={activeCompany === "all"}
            onClick={() => { setActiveCompany("all"); setCompanySidebarOpen(false); }}
          />
          {loadingCompanies ? (
            <div className="flex justify-center py-6"><Spinner /></div>
          ) : (
            companies.map((co) => (
              <CoItem
                key={co.id}
                label={co.company_name}
                count={invCountByCompany[String(co.id)] || 0}
                active={activeCompany === String(co.id)}
                onClick={() => { setActiveCompany(String(co.id)); setCompanySidebarOpen(false); }}
              />
            ))
          )}
        </div>
      </aside>

      {/* ── Main area ── */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">

        {/* ── Stat cards (always visible) ── */}
        <div className="shrink-0 grid grid-cols-2 xl:grid-cols-4 gap-2 sm:gap-3 p-2.5 sm:p-4 border-b border-slate-100 bg-white">
          {/* Mobile: company filter button in stats bar */}
          <div className="col-span-2 xl:hidden flex items-center gap-2 mb-1">
            <button
              onClick={() => setCompanySidebarOpen(true)}
              className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
            >
              🏢 {activeCompany === "all" ? "All companies" : companies.find((c) => String(c.id) === activeCompany)?.company_name || "Company"}
              <span className="text-slate-400">▾</span>
            </button>
          </div>
          {[
            { label: "Total", value: stats.total, sub: "invoices", color: "text-indigo-600", bg: "bg-indigo-50" },
            { label: "Value", value: inr(stats.totalValue), sub: "total", color: "text-violet-600", bg: "bg-violet-50" },
            { label: "Paid", value: stats.paid, sub: "settled", color: "text-emerald-600", bg: "bg-emerald-50" },
            { label: "Awaiting", value: stats.awaiting, sub: "pending", color: "text-amber-600", bg: "bg-amber-50" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg sm:rounded-xl border border-slate-100 p-2.5 sm:p-3.5">
              <p className="text-[10px] sm:text-xs text-slate-500 mb-0.5 sm:mb-1">{s.label}</p>
              <p className={`text-base sm:text-xl font-bold ${s.color} truncate`}>{s.value}</p>
              <p className="text-[9px] sm:text-[11px] text-slate-400 mt-0.5 hidden sm:block">{s.sub}</p>
            </div>
          ))}
        </div>

        {/* ── Content area (list + detail) ── */}
        <div className="flex-1 flex overflow-hidden">

          {/* ── Invoice list ── 
              Desktop: always visible (fixed width)
              Mobile: shown when mobileView === "list"
          ── */}
          <div
            className={`
              flex flex-col bg-white border-r border-slate-100 overflow-hidden
              ${mobileView === "list" ? "flex" : "hidden"}
              md:flex md:w-[280px] lg:w-[300px] md:min-w-[280px] lg:min-w-[300px]
              w-full
            `}
          >
            {/* header */}
            <div className="flex items-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 border-b border-slate-100">
              <div className="flex-1 min-w-0">
                <p className="text-xs sm:text-sm font-semibold text-slate-900 truncate">
                  {activeCompany === "all"
                    ? "All invoices"
                    : companies.find((c) => String(c.id) === activeCompany)?.company_name || "Invoices"}
                </p>
                <p className="text-[10px] sm:text-[11px] text-slate-400">
                  {filteredInvoices.length} invoice{filteredInvoices.length !== 1 ? "s" : ""}
                </p>
              </div>
            </div>

            {/* search */}
            <div className="px-2.5 sm:px-3 py-2 sm:py-2.5 border-b border-slate-100">
              <div className="relative">
                <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 text-xs">🔍</span>
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search invoices…"
                  className="w-full pl-7 sm:pl-8 pr-3 py-1.5 sm:py-2 text-xs sm:text-sm border border-slate-200 rounded-xl bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-300 placeholder-slate-400 transition"
                />
              </div>
            </div>

            {/* tabs */}
            <div className="flex gap-1 px-2.5 sm:px-3 py-1.5 sm:py-2 border-b border-slate-100 overflow-x-auto scrollbar-none">
              {tabCounts.map((t) => (
                <button
                  key={t.label}
                  onClick={() => setActiveTab(t.label)}
                  className={`flex items-center gap-1 px-2 sm:px-2.5 py-1 sm:py-1.5 rounded-lg text-[11px] sm:text-xs font-semibold whitespace-nowrap transition ${
                    activeTab === t.label ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"
                  }`}
                >
                  {t.label}
                  <span className={`text-[9px] sm:text-[10px] rounded-full px-1 sm:px-1.5 ${activeTab === t.label ? "bg-white/20" : "bg-slate-200 text-slate-600"}`}>
                    {t.count}
                  </span>
                </button>
              ))}
            </div>

            {/* list */}
            <div className="flex-1 overflow-y-auto px-1.5 sm:px-2 py-1.5 sm:py-2 space-y-1 sm:space-y-1.5">
              {loadingInvoices ? (
                <div className="flex justify-center py-12"><Spinner size={22} /></div>
              ) : filteredInvoices.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-16 text-slate-300 gap-2">
                  <span className="text-3xl">📋</span>
                  <p className="text-xs">No invoices found</p>
                </div>
              ) : (
                filteredInvoices.map((inv) => {
                  const cat = classifyStatus(inv.paymentStatus);
                  const isActive = selectedInvoice?.id === inv.id;
                  return (
                    <button
                      key={inv.id}
                      onClick={() => handleSelectInvoice(inv)}
                      className={`w-full text-left p-3 sm:p-3.5 rounded-xl sm:rounded-2xl border transition-all active:scale-[0.98] ${
                        isActive
                          ? "border-indigo-200 bg-indigo-50/60 ring-1 ring-indigo-100"
                          : "border-slate-100 bg-white hover:border-slate-200 hover:shadow-sm"
                      }`}
                    >
                      <div className="flex items-start justify-between mb-1 gap-1">
                        <p className="text-xs sm:text-sm font-semibold text-slate-900 truncate">{inv.invoiceNo}</p>
                        <div className="shrink-0"><StatusBadge status={inv.paymentStatus} /></div>
                      </div>
                      <p className="text-[10px] sm:text-[11px] text-slate-400 mb-1 truncate">
                        {inv.source} → {inv.destination}
                      </p>
                      <div className="flex justify-between text-[10px] sm:text-[11px] text-slate-400">
                        <span>{fmtDate(inv.createdAt)}</span>
                        <span className="font-semibold text-slate-700">{inr(inv.invoiceValue)}</span>
                      </div>
                      <div className="mt-1.5 sm:mt-2 w-full h-1 rounded-full bg-slate-100 overflow-hidden">
                        <div
                          className={`h-full rounded-full ${PROGRESS_COLOR[cat]} transition-all`}
                          style={{ width: `${progressPct(cat)}%` }}
                        />
                      </div>
                    </button>
                  );
                })
              )}
            </div>
          </div>

          {/* ── Detail panel ──
              Desktop: always visible (flex-1)
              Mobile: shown when mobileView === "detail"
          ── */}
          <div
            className={`
              flex-1 flex flex-col overflow-hidden
              ${mobileView === "detail" ? "flex" : "hidden"}
              md:flex
            `}
          >
            <DetailPanel
              key={selectedInvoice?.id}
              invoice={selectedInvoice}
              onEdit={() => setEditOpen(true)}
              onViewPdf={(items) => setPdfItems(items)}
              onBack={() => setMobileView("list")}
            />
          </div>
        </div>
      </div>

      {/* ── Overlays ── */}
      {editOpen && selectedInvoice && (
        <EditModal
          invoice={selectedInvoice}
          onClose={() => setEditOpen(false)}
          onSave={handleSaveEdit}
        />
      )}
      {pdfItems !== null && selectedInvoice && (
        <PdfViewer
          invoice={selectedInvoice}
          items={pdfItems}
          onClose={() => setPdfItems(null)}
        />
      )}
    </div>
  );
}